document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".tab-btn");
    const tabContents = document.querySelectorAll(".tab-content");

    function activateTab(button, updateUrl = true) {
      const targetTab = button.getAttribute("data-tab");
      const tabQuery = button.getAttribute("data-query");

      // Remove active classes
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((tab) => tab.classList.remove("active"));

      // Add active classes
      button.classList.add("active");
      document.getElementById(targetTab).classList.add("active");

      // Update URL
      if (updateUrl && tabQuery) {
        const url = new URL(window.location);
        url.searchParams.set("tab", tabQuery);
        window.history.replaceState({}, "", url); // replace on load
      }
    }

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => activateTab(button));
    });

    const urlParams = new URLSearchParams(window.location.search);
    const tabFromUrl = urlParams.get("tab");

    if (tabFromUrl) {
      // Case 1: URL already has tab
      const matchingButton = document.querySelector(
        `.tab-btn[data-query="${tabFromUrl}"]`
      );

      if (matchingButton) {
        activateTab(matchingButton, false);
        return;
      }
    }

    // Case 2: No tab in URL → use default active tab
    const defaultActiveTab = document.querySelector(".tab-btn.active");

    if (defaultActiveTab) {
      activateTab(defaultActiveTab);
    }
});

//   document.addEventListener("DOMContentLoaded", function () {
//     const bundleButtons = document.querySelectorAll(".bundle-atc");

//     bundleButtons.forEach((button) => {
//       button.addEventListener("click", async function () {
//         const productHandles = button.dataset.products
//           .split(",")
//           .filter(Boolean);

//         if (productHandles.length === 0) return;

//         const formItems = [];

//         for (const handle of productHandles) {
//           try {
//             const res = await fetch(`/products/${handle}.js`);
//             const product = await res.json();
//             if (product.variants && product.variants.length > 0) {
//               formItems.push({
//                 id: product.variants[0].id,
//                 quantity: 1,
//               });
//             }
//           } catch (error) {
//             console.error("Product not found:", handle);
//           }
//         }

//         if (formItems.length > 0) {
//           fetch("/cart/add.js", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//             },
//             body: JSON.stringify({ items: formItems }),
//           })
//             .then((res) => res.json())
//             .then((data) => {
//             //   
//               // Optional: show confirmation or reload cart
//                if (window.openSidecart) {
//             window.openSidecart();
//             if (window.fetchCart) window.fetchCart();
//           }
//             })
//             .catch((err) => {
//               console.error("Error adding bundle:", err);
//             });
//         }
//       });
//     });
//   });
////////////////////////////////////quanity box js//////////////
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll('.quantity__input').forEach(input => {
//     const wrapper = input.closest('.number-input');
//     const minusBtn = wrapper.querySelector('.minus');
//     const plusBtn = wrapper.querySelector('.plus');

//     minusBtn.addEventListener('click', () => {
//       input.value = Math.max(0, parseInt(input.value) - 1);
//       input.dispatchEvent(new Event('input', { bubbles: true }));
//     });

//     plusBtn.addEventListener('click', () => {
//       input.value = parseInt(input.value) + 1;
//       input.dispatchEvent(new Event('input', { bubbles: true }));
//     });
//   });
// });
// Bundle-builder-selsection-code will start from here
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll('.bundle-builder-atc').forEach(button => {
//     button.addEventListener('click', () => {
//       const container = button.closest('.product-blockss');
//       if (!container) return;

//       const rightBlocks = Array.from(document.querySelectorAll('.Bundle-right-content'));

//       // Get bundleTitle from button's data-title attribute
//       const bundleTitle = button.getAttribute('data-title')?.trim() || '';

//       const bundleItems = [];

//       for (let i = 1; i <= 4; i++) {
//         const block = container.querySelector(`.product-image${i}`);
//         const imgEl = block?.querySelector('img');
//         if (!imgEl || !imgEl.src || imgEl.src.includes('no-image')) continue;

//         block.setAttribute('data-quantity', '1');

//         const productId = block.getAttribute('data-product-id') || '';
//         const variantId = block.getAttribute('data-variant-id') || '';
//         const subscription = block.getAttribute('data-subscription') || 'false';
//         const title = block.getAttribute('data-product-title') || '';

//         bundleItems.push({
//           productId,
//           variantId,
//           subscription,
//           title
//         });
//       }

//       if (bundleItems.length === 0) return;

//       const bundleKey = bundleItems.map(item => item.variantId).sort().join(',');

//       const existingBlock = rightBlocks.find(rb => rb.dataset.bundleKey === bundleKey);

//       if (existingBlock) {
//         const currentQty = parseInt(existingBlock.dataset.quantity, 10) || 0;
//         const newQty = currentQty + 1;
//         existingBlock.dataset.quantity = newQty;
//         existingBlock.querySelector('.selected-bundle-qty').textContent = newQty;
//       } else {
//         const emptyBlock = rightBlocks.find(rb => !rb.dataset.productId);
//         if (!emptyBlock) return;

//         emptyBlock.dataset.productId = bundleItems[0].productId;
//         emptyBlock.dataset.variantId = bundleItems[0].variantId;
//         emptyBlock.dataset.bundleKey = bundleKey;
//         emptyBlock.dataset.quantity = 1;
//         emptyBlock.dataset.hasSubscription = bundleItems.some(item => item.subscription !== 'false') ? 'true' : 'false';

//         // ✅ Inject bundle title into the attribute too
//         emptyBlock.dataset.bundleTitle = bundleTitle;

//         // Update title + product list
//         const productTitles = bundleItems.map(item => `<li>${item.title}</li>`).join('');
//         emptyBlock.querySelector('.selected-bundle-products').innerHTML = `<ul>${productTitles}</ul>`;
//         emptyBlock.querySelector('.selected-bundle-title').textContent = bundleTitle;
//         emptyBlock.querySelector('.selected-bundle-qty').textContent = 1;

//         const removeBtn = emptyBlock.querySelector('.bundle-remove');
//         if (removeBtn) {
//           removeBtn.innerHTML = '<button type="button" class="remove-btn">×</button>';
//         }
//       }
//     });
//   });
// });

 
/////////////////////Bundle  secents logic /////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
  // Select placeholders from BOTH main and sticky bars
  const placeholders = Array.from(document.querySelectorAll('.selection-slots .placeholder'));

  document.querySelectorAll('.bundle-atc').forEach(button => {
    button.addEventListener('click', () => {
      const container = button.closest('.product-blockss');
      const isSingleProduct = button.hasAttribute('data-single-product');
      const singleTitle = button.getAttribute('data-single-product')?.trim();
      const isAddon = button.hasAttribute('data-addon-product');
      const higherpriceitem = button.hasAttribute('data-tags');
      const isnodiscountot = button.hasAttribute('data-discount-tag');

      if (!container) return;

      if (isSingleProduct) {
        const productImageEl = container.querySelector('.product-image1 img');
        const variantId = container.querySelector('.product-image1')?.getAttribute('data-variant-id') || '';
        const productId = container.querySelector('.product-image1')?.getAttribute('data-product-id') || '';
        const subscription = container.querySelector('.product-image1')?.getAttribute('data-subscription') || 'false';
        const productTitle = container.querySelector('.product-image1')?.getAttribute('data-product-title') || '';
        const productPrice = container.querySelector('.product-image1')?.getAttribute('data-price') || '';

        if (!productImageEl || productImageEl.src.includes('no-image')) {
          console.log(" No valid image found for single product.");
          return;
        }

        // 1. Update placeholder section (Updates BOTH Main and Sticky)
        let matchingSlots = placeholders.filter(ph => ph.dataset.variantId === variantId);
        
        if (matchingSlots.length > 0) {
          matchingSlots.forEach(slot => {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const newQty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
            qtyEl.textContent = newQty;
            slot.setAttribute('data-quantity', newQty);
            slot.dataset.isAddon = isAddon ? 'true' : 'false';
            slot.dataset.higherpriceitem = higherpriceitem ? 'true' : 'false';
            slot.dataset.isnodiscountot = isnodiscountot ? 'true' : 'false';
                  slot.dataset.isMist = container
        .querySelector('.product-image1')
        ?.getAttribute('data-is-mist') === 'true'
          ? 'true'
          : 'false';

          });
        } else {
          // Find the first available index that is empty in BOTH locations
          const firstEmpty = placeholders.find(ph => !ph.dataset.image);
          if (firstEmpty) {
            const idx = firstEmpty.dataset.index;
            // Target all slots with this specific index (Main + Sticky)
            const syncedSlots = document.querySelectorAll(`.placeholder[data-index="${idx}"]`);
            
            syncedSlots.forEach(slot => {
              slot.dataset.image = productImageEl.src;
              slot.dataset.productId = productId;
              slot.dataset.variantId = variantId;
              slot.dataset.quantity = '1';
              slot.dataset.hasSubscription = subscription;
              slot.dataset.title = productTitle;
              slot.dataset.price = productPrice;
              slot.dataset.isAddon = isAddon ? 'true' : 'false';
              slot.dataset.higherpriceitem = higherpriceitem ? 'true' : 'false';
              slot.dataset.isnodiscountot = isnodiscountot ? 'true' : 'false';
              slot.dataset.isMist = container
              .querySelector('.product-image1')
              ?.getAttribute('data-is-mist') === 'true'
                ? 'true'
                : 'false';

              slot.querySelector(`.product-image${idx}`).innerHTML = `<img src="${productImageEl.src}" alt="">`;
              slot.querySelector(`.product-qty${idx}`).textContent = '1';
              slot.querySelector('.remove-btn')?.classList.remove('hidden');
              updateProductRightBlocksActive(slot);
            });
            updatePlaceholderActiveState();
            updateTabDots();
          }
        }

        // 2. Update .Bundle-right-content
        let singleBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
          .find(el => el.dataset.variantIds === variantId);

        if (singleBlock) {
          const qtyEl = singleBlock.querySelector('.selected-bundle-qty');
          const updatedQty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
          qtyEl.textContent = updatedQty;
          singleBlock.setAttribute('data-quantity', updatedQty);
        } else {
          const emptyBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
            .find(el => !el.dataset.image);

          if (emptyBlock) {
            emptyBlock.setAttribute('data-bundle-title', '');
            emptyBlock.setAttribute('data-quantity', '1');
            emptyBlock.setAttribute('data-image', productImageEl.src);
            emptyBlock.setAttribute('data-product-id', productId);
            emptyBlock.setAttribute('data-variant-ids', variantId);
            emptyBlock.setAttribute('data-has-subscription', subscription);

            const titleEl = emptyBlock.querySelector('.selected-bundle-title');
            const productsEl = emptyBlock.querySelector('.selected-bundle-products');
            const qtyEl = emptyBlock.querySelector('.selected-bundle-qty');

            if (titleEl) titleEl.textContent = singleTitle;
            if (productsEl) productsEl.innerHTML = '';
            if (qtyEl) qtyEl.textContent = '1';
          }
          toggleEmptyBundleMessage();
          updateOneTimePriceDisplay();
          updateSubscriptionPriceDisplay();
          updateAtcPriceBySelection();
          updateTabDots();
        }

        // 3. Setup qty box
        const qtyInput = container.querySelector('.quantity__input');
        const minusBtn = container.querySelector('.qty-btn.minus');
        const plusBtn = container.querySelector('.qty-btn.plus');

        qtyInput.value = 1;
        button.style.display = 'none';
        container.querySelector('.bundle-qtty').style.display = 'flex';
        container.classList.add('active');

  plusBtn.onclick = () => {
    
      let newVal = parseInt(qtyInput.value, 10) + 1;
      qtyInput.value = newVal;

      let block = Array.from(document.querySelectorAll('.Bundle-right-content'))
        .find(el => el.dataset.variantIds === variantId);
      if (block) {
        block.querySelector('.selected-bundle-qty').textContent = newVal;
        block.setAttribute('data-quantity', newVal);
      }

      const matchingSlots = placeholders.filter(ph => ph.dataset.variantId === variantId);
      matchingSlots.forEach(slot => {
        const idx = slot.dataset.index;
        const qtyEl = slot.querySelector(`.product-qty${idx}`);
        const updated = (parseInt(qtyEl.textContent, 10) || 0) + 1;
        qtyEl.textContent = updated;
        slot.setAttribute('data-quantity', updated);
        updateProductRightBlocksActive(slot); // ensures sticky UI updates
      });

      
      toggleEmptyBundleMessage();
      updateOneTimePriceDisplay();
      updateSubscriptionPriceDisplay();
      updatePlaceholderActiveState();
      updateAtcPriceBySelection();
      updateTabDots();

    };
    minusBtn.onclick = () => {
        let newVal = Math.max(0, parseInt(qtyInput.value, 10) - 1);
        qtyInput.value = newVal;

        let block = Array.from(document.querySelectorAll('.Bundle-right-content'))
          .find(el => el.dataset.variantIds === variantId);
        if (block) {
          block.querySelector('.selected-bundle-qty').textContent = newVal;
          block.setAttribute('data-quantity', newVal);

          if (newVal === 0) {
            block.setAttribute('data-quantity', '0');
            block.removeAttribute('data-image');
            block.removeAttribute('data-product-id');
            block.removeAttribute('data-variant-ids');
            block.removeAttribute('data-has-subscription');
            // block.removeAttribute('data-quantity');
            block.querySelector('.selected-bundle-title').textContent = '';
            block.querySelector('.selected-bundle-qty').textContent = '';
          }
        }

        const matchingSlots = placeholders.filter(ph => ph.dataset.variantId === variantId);
      matchingSlots.forEach(slot => {
        const idx = slot.dataset.index;
        const updatedVal = Math.max(0, parseInt(slot.querySelector(`.product-qty${idx}`).textContent, 10) - 1);
        slot.querySelector(`.product-qty${idx}`).textContent = updatedVal;
        slot.setAttribute('data-quantity', updatedVal);

        if (updatedVal === 0) {
          slot.querySelector(`.product-image${idx}`).innerHTML =
            `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538230652.png?v=1769540059" alt="placeholder">`;
          delete slot.dataset.image;
          delete slot.dataset.productId;
          delete slot.dataset.variantId;
          // delete slot.dataset.quantity;
          slot.dataset.quantity = '0';
          delete slot.dataset.hasSubscription;
        }

        updateProductRightBlocksActive(slot);
      });

        if (newVal === 0) {
          button.style.display = '';
          container.querySelector('.bundle-qtty').style.display = 'none';
          container.classList.remove('active');
        }
            toggleEmptyBundleMessage();
        updateOneTimePriceDisplay();
        updateSubscriptionPriceDisplay();
        updatePlaceholderActiveState();
        updateAtcPriceBySelection();
        updateTabDots();
      };

        return; 
      }

      // BUNDLE LOGIC
      const productEntries = [];
      for (let i = 1; i <= 4; i++) {
        const block = container.querySelector(`.product-image${i}`);
        const imgEl = block?.querySelector('img');
        if (!imgEl || !imgEl.src || imgEl.src.includes('no-image')) continue;

        block.setAttribute('data-quantity', '1');
        productEntries.push({
          src: imgEl.src,
          productId: block.getAttribute('data-product-id') || '',
          variantId: block.getAttribute('data-variant-id') || '',
          subscription: block.getAttribute('data-subscription') || 'false',
          block: block
        });
      }

      productEntries.forEach(({ src, productId, variantId, subscription, block }) => {
        let matchingSlots = placeholders.filter(ph => ph.dataset.image === src);
        if (matchingSlots.length > 0) {
          matchingSlots.forEach(slot => {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const updated = (parseInt(qtyEl.textContent, 10) || 0) + 1;
            qtyEl.textContent = updated;
            slot.setAttribute('data-quantity', updated);
          });
        } else {
          const firstEmpty = placeholders.find(ph => !ph.dataset.image);
          if (!firstEmpty) return;

          const idx = firstEmpty.dataset.index;
          const syncedSlots = document.querySelectorAll(`.placeholder[data-index="${idx}"]`);
          const price = block.getAttribute('data-price') || '0';
          const productBlock = container.querySelector(`[data-product-id="${productId}"][data-variant-id="${variantId}"]`);
          const title = productBlock?.getAttribute('data-product-title') || '';

          syncedSlots.forEach(slot => {
            slot.dataset.image = src;
            slot.dataset.productId = productId;
            slot.dataset.variantId = variantId;
            slot.dataset.quantity = '1';
            slot.dataset.hasSubscription = subscription;
            slot.dataset.price = price;
            slot.dataset.title = title;
            slot.querySelector(`.product-image${idx}`).innerHTML = `<img src="${src}" alt="">`;
            slot.querySelector(`.product-qty${idx}`).textContent = '1';
            slot.querySelector('.remove-btn')?.classList.remove('hidden');
            updateProductRightBlocksActive(slot);
          });
          
        }
      });

      updatePlaceholderActiveState();
      const bundleTitle = button.getAttribute('data-title-new')?.trim() || "Untitled Bundle";
      const productNames = productEntries.map(p => p.block?.getAttribute("data-product-title")).filter(Boolean);

      let bundleBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
        .find(el => el.getAttribute('data-bundle-title') === bundleTitle);

      if (bundleBlock) {
        const qtyEl = bundleBlock.querySelector('.selected-bundle-qty');
        const updatedQty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
        qtyEl.textContent = updatedQty;
        bundleBlock.setAttribute('data-quantity', updatedQty);
      } else {
        const emptyBlock = Array.from(document.querySelectorAll('.Bundle-right-content')).find(el => {
          return !el.getAttribute('data-bundle-title') && !el.getAttribute('data-product-id') && !el.getAttribute('data-image');
        });

        if (emptyBlock) {
          const firstEntry = productEntries[0];
          emptyBlock.setAttribute('data-bundle-title', bundleTitle);
          emptyBlock.setAttribute('data-quantity', '1');
          emptyBlock.setAttribute('data-image', firstEntry?.src || '');
          emptyBlock.setAttribute('data-product-id', firstEntry?.productId || '');
          const allVariantIds = productEntries.map(p => p.variantId).filter(Boolean);
          emptyBlock.setAttribute('data-variant-ids', allVariantIds.join(','));
          emptyBlock.setAttribute('data-has-subscription', firstEntry?.subscription || 'false');

          const titleEl = emptyBlock.querySelector('.selected-bundle-title');
          const productsEl = emptyBlock.querySelector('.selected-bundle-products');
          const qtyEl = emptyBlock.querySelector('.selected-bundle-qty');

          if (titleEl) titleEl.textContent = bundleTitle.split('_')[0].toUpperCase();
          if (productsEl) productsEl.innerHTML = productNames.map(name => `<div>${name}</div>`).join('');
          if (qtyEl) qtyEl.textContent = '1';
        }
        toggleEmptyBundleMessage();
        updateOneTimePriceDisplay();
        updateSubscriptionPriceDisplay();
        updateAtcPriceBySelection();
        updateTabDots();
      }

      const qtyInput = container.querySelector('.quantity__input');
      const minusBtn = container.querySelector('.qty-btn.minus');
      const plusBtn = container.querySelector('.qty-btn.plus');

      qtyInput.value = 1;
      button.style.display = 'none';
      container.querySelector('.bundle-qtty').style.display = 'flex';
      container.classList.add('active');

      plusBtn.onclick = () => {
        let newVal = parseInt(qtyInput.value, 10) + 1;
        qtyInput.value = newVal;
        const currentBundleTitle = button.getAttribute('data-title-new')?.trim() || "Untitled Bundle";
        const bBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
          .find(el => el.getAttribute('data-bundle-title') === currentBundleTitle);
        if (bBlock) {
          const qEl = bBlock.querySelector('.selected-bundle-qty');
          const nQty = (parseInt(qEl.textContent, 10) || 0) + 1;
          qEl.textContent = nQty;
          bBlock.setAttribute('data-quantity', nQty);
        }

        productEntries.forEach(({ src, block }) => {
          const matchingSlots = placeholders.filter(ph => ph.dataset.image === src);
          matchingSlots.forEach(slot => {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const updated = (parseInt(qtyEl.textContent, 10) || 0) + 1;
            qtyEl.textContent = updated;
            slot.setAttribute('data-quantity', updated);
            block.setAttribute('data-quantity', updated);
            updateProductRightBlocksActive(slot);
          });
        });
        toggleEmptyBundleMessage();
        updateOneTimePriceDisplay();
        updateSubscriptionPriceDisplay();
        updatePlaceholderActiveState();
        updateAtcPriceBySelection();
        updateTabDots();
      };

      minusBtn.onclick = () => {
        let newVal = Math.max(0, parseInt(qtyInput.value, 10) - 1);
        qtyInput.value = newVal;
        const currentBundleTitle = button.getAttribute('data-title-new')?.trim() || "Untitled Bundle";
        const bBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
          .find(el => el.getAttribute('data-bundle-title') === currentBundleTitle);
        
        if (bBlock) {
          const qEl = bBlock.querySelector('.selected-bundle-qty');
          const nQty = Math.max(0, (parseInt(qEl.textContent, 10) || 0) - 1);
          qEl.textContent = nQty;
          bBlock.setAttribute('data-quantity', nQty);

          if (nQty === 0) {
            bBlock.setAttribute('data-quantity', '0');
            bBlock.setAttribute('data-bundle-title', '');
            bBlock.querySelector('.selected-bundle-title').textContent = '';
            bBlock.querySelector('.selected-bundle-products').innerHTML = '';
            bBlock.querySelector('.selected-bundle-qty').textContent = '';
          }
          updatePlaceholderActiveState();
        }

        productEntries.forEach(({ src, block }) => {
          const matchingSlots = placeholders.filter(ph => ph.dataset.image === src);
          matchingSlots.forEach(slot => {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const updatedVal = Math.max(0, (parseInt(qtyEl.textContent, 10) || 0) - 1);
            qtyEl.textContent = updatedVal;
            slot.setAttribute('data-quantity', updatedVal);
            block.setAttribute('data-quantity', updatedVal);

            if (updatedVal === 0) {
              delete slot.dataset.image;
              delete slot.dataset.productId;
              delete slot.dataset.variantId;
              // delete slot.dataset.quantity;
              slot.dataset.quantity = '0';
              delete slot.dataset.hasSubscription;
              slot.querySelector(`.product-image${idx}`).innerHTML =
                `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538230652.png?v=1769540059" alt="placeholder">`;
              block.removeAttribute('data-quantity'); 
            }
            updateProductRightBlocksActive(slot);
          });
        });

        if (newVal === 0) {
          button.style.display = '';
          container.querySelector('.bundle-qtty').style.display = 'none';
          container.classList.remove('active');
        }
        toggleEmptyBundleMessage();
        updateOneTimePriceDisplay();
        updateSubscriptionPriceDisplay();
        updatePlaceholderActiveState();
        updateAtcPriceBySelection();
        updateTabDots();
      };
    });
  });
});

function updateProductRightBlocksActive(updatedSlot) {
  // 1. Existing Logic for individual slot blocks
  if (updatedSlot) {
    const productRightBlock = updatedSlot.closest('.product-right-block');
    if (productRightBlock) {
      const isActive = updatedSlot.dataset.image && parseInt(updatedSlot.dataset.quantity, 10) > 0;
      productRightBlock.classList.toggle('active', !!isActive);
    }
  } else {
    const slotBlocks = document.querySelectorAll('.selection-slots .product-right-block');
    slotBlocks.forEach(block => {
      const placeholder = block.querySelector('.placeholder');
      const isActive = placeholder && placeholder.dataset.image && parseInt(placeholder.dataset.quantity, 10) > 0;
      block.classList.toggle('active', !!isActive);
    });
  }

  // 2. NEW: Toggle active class on the Sticky Summary Parent
  const stickySummary = document.querySelector('.sticky-product-summary');
  if (stickySummary) {
    // Check if any placeholder on the page currently has an image selected
    const hasAnySelected = Array.from(document.querySelectorAll('.placeholder'))
                                .some(ph => ph.dataset.image && parseInt(ph.dataset.quantity, 10) > 0);
    
    stickySummary.classList.toggle('active', hasAnySelected);
  }
}

      function updateTabDots() {
        document.querySelectorAll('.tabs-wrapper').forEach(wrapper => {
          const buttons = wrapper.querySelectorAll('.tab-btn');
          const contents = wrapper.querySelectorAll('.tab-content');

          buttons.forEach((btn, index) => {
            const content = contents[index];

            if (content) {
              // Delay to ensure .active class is applied
              setTimeout(() => {
                let hasActiveProduct = false;

                const activeBlock = content.querySelector('.product-blockss.active');
                if (activeBlock) {
                  hasActiveProduct = true;
                }

                // Select the dot inside the same wrapper
                const dot = btn.parentElement.querySelector('.tab-dot');
                if (dot) {
                  if (hasActiveProduct) {
                    dot.classList.remove('hidden');
                    dot.classList.add('visible');
                  } else {
                    dot.classList.add('hidden');
                    dot.classList.remove('visible');
                  }
                }

              }, 50); // 50ms delay
            }
          });
        });
      }

function updatePlaceholderActiveState() {
  const placeholders = document.querySelectorAll('#selected-scents .placeholder');

  placeholders.forEach(ph => {
    const hasProduct = ph.querySelector('.product-title') || ph.dataset.productId;

    if (hasProduct) {
      ph.classList.add('active');
    } else {
      ph.classList.remove('active');
    }
  });
}

// Subscription code start from here

document.addEventListener("DOMContentLoaded", function() {
  const sourceEl = document.querySelector('.product-image1');
  const priceCents = sourceEl?.getAttribute('data-price');

  if (priceCents) {
    const price = (parseInt(priceCents, 10) / 100).toFixed(2); // ✅ convert to dollars
    const targetElements = document.querySelectorAll('.one-time-discount-price');

    targetElements.forEach(el => {
      el.innerHTML += ` $${price}`;
    });
  }
});

//  Updated Add to Cart code (based on .Bundle-right-content blocks instead of .placeholder)
// let bypassPopup = false;
// document.addEventListener("DOMContentLoaded", function () {
//   const atcBtns = document.querySelectorAll('.bundle-product-atc, .bundle-sticky-atc');

//   if (!atcBtns.length) return;

//   atcBtns.forEach(atcBtn => {
//     atcBtn.addEventListener("click", async function () {
//       atcBtn.classList.add("disable");
//       atcBtn.classList.add('loading');   // --- Show loader on button ---

//       const hasItems = Array.from(document.querySelectorAll('.Bundle-right-content'))
//   .some(b => parseInt(b.dataset.quantity, 10) > 0);

//     if (!hasItems) {
//       alert("Please select at least one scent or bundle.");
//       atcBtn.classList.remove("disable", "loading");
//       atcBtn.disabled = false;
//       return; 
//     }
//     // ------------------------------
// // STEP 1: Detect if user selected ONE-TIME
// // ------------------------------
//     const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
//     // --- NEW LOGIC START ---
//     // Check if any selected item is a *subscription-eligible* product
//     const hasSubscriptionEligibleItem = Array.from(document.querySelectorAll('.Bundle-right-content'))
//         .some(block => {
//             const quantity = parseInt(block.dataset.quantity, 10) || 0;
//             const hasSubscription = block.dataset.hasSubscription;
//             // Only check blocks with quantity > 0
//             if (quantity <= 0) return false;

//             // Return true if the block is selected AND has subscription capability
//             return hasSubscription && hasSubscription !== "false" && hasSubscription !== "0";
//         });
//     // --- NEW LOGIC END ---
 
//   // IF user selected One-time AND popup not bypassed → show popup
// if (purchaseOption === "onetime" && !bypassPopup && hasSubscriptionEligibleItem) {

//     const popup = document.getElementById("onetime-popup");
//     popup.classList.remove("hidden");
//     document.getElementById("popup-overlay").classList.remove("hidden");
//     atcBtn.classList.remove("disable", "loading");
//     atcBtn.disabled = false;
//     return; // stop normal ATC flow
//   }

//       const blocks = Array.from(document.querySelectorAll('.Bundle-right-content'));
//       const items = [];
//       let hasValidProduct = false;
//       const processedBundles = new Set();

//       blocks.forEach((block, i) => {
//         const uniqueId = `m${Math.random().toString(36).substr(2, 9)}`;
//         const fullBundleTitle = block.dataset.bundleTitle?.trim();
//         const bundleTitle = fullBundleTitle?.split('_')[0];
//         const quantity = parseInt(block.dataset.quantity, 10) || 1;
//         const hasSubscription = block.dataset.hasSubscription;
//         const variantIds = (block.dataset.variantIds || '').split(',').map(id => id.trim()).filter(Boolean);

//         if (variantIds.length === 0 || quantity <= 0) return;
//         hasValidProduct = true;

//         //  BUNDLE product
//         if (fullBundleTitle) {
//           if (processedBundles.has(fullBundleTitle)) return;
//           processedBundles.add(fullBundleTitle);

//           const titles = Array.from(block.querySelectorAll('.selected-bundle-products div')).map(d => d.textContent.trim());

//           variantIds.forEach((variantId, index) => {
//             const item = {
//               id: parseInt(variantIds[index], 10),
//               quantity: quantity,
//               properties: {
//                 "_bundle_items": true,
//                 "_unique_id": uniqueId,
//                 "Bundle Name": bundleTitle,
//                 "Included Products": titles.join(', ')
//               }
//             };

//             const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
//             if (purchaseOption === "subscription" && hasSubscription !== "false" && hasSubscription !== "0") {
//               const planSelect = document.querySelector(`.subscription-dropdown[data-product-id="${variantId}"]`);
//               const selectedOption = planSelect?.selectedOptions[0];
//               const sellingPlanId = selectedOption?.value;

//               if (sellingPlanId) {
//                 item.selling_plan = parseInt(sellingPlanId, 10);
//               }
//             } else {
//               item.properties["Purchase Type"] = "One Time";
//             }

//             items.push(item);
//           });

//         } 
//         //  SINGLE product
//         else {
//           const item = {
//             id: parseInt(variantIds[0], 10),
//             quantity: quantity,
//             properties: {}
//           };

//           const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
//           if (purchaseOption === "subscription" && hasSubscription !== "false" && hasSubscription !== "0") {
//             const planSelect = document.querySelector(`.subscription-dropdown[data-product-id="${variantIds[0]}"]`);
//             const selectedOption = planSelect?.selectedOptions[0];
//             const sellingPlanId = selectedOption?.value;

//             if (sellingPlanId) {
//               item.selling_plan = parseInt(sellingPlanId, 10);
//             }
//           } else {
//             item.properties["Purchase Type"] = "One Time";
//           }

//           if (Object.keys(item.properties).length === 1 && item.properties["Purchase Type"]) {
//             delete item.properties;
//           }

//           items.push(item);
//         }
//       });

//       if (!hasValidProduct) {
//         alert("Please select at least one scent or bundle.");
//         atcBtn.classList.remove("disable", "loading");
//         atcBtn.disabled = false;
//         return;
//       }

//       try {
//         const response = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ items })
//         });

//         if (!response.ok) {
//           const errData = await response.json();
//           throw new Error(errData.description || "Unknown cart error");
//         }

//         const data = await response.json();

//         if (window.openSidecart) {
//           window.openSidecart();
//           if (window.fetchCart) window.fetchCart();
//         }
//       } catch (err) {
//         console.error(" Cart add failed:", err);
//         alert(err);
//       } finally {
//         atcBtn.disabled = false;
//         atcBtn.classList.remove("disable", "loading");
//         bypassPopup = false;
//       }
//     });
//   });

// const subBtn = document.getElementById("continue-subscription");
// const onetimeBtn = document.getElementById("continue-onetime");

// subBtn.addEventListener("click", function () {
//   const subRadio = document.querySelector('input[name="purchase-option"][value="subscription"]');
//   if (subRadio) subRadio.checked = true;

//   document.getElementById("onetime-popup").classList.add("hidden");
//   document.getElementById("popup-overlay").classList.add("hidden");
//   bypassPopup = true;

//   document.querySelector('.bundle-product-atc, .bundle-sticky-atc').click();
// });

// onetimeBtn.addEventListener("click", function () {
//   document.getElementById("onetime-popup").classList.add("hidden");
//   document.getElementById("popup-overlay").classList.add("hidden");
//   bypassPopup = true;

//   document.querySelector('.bundle-product-atc, .bundle-sticky-atc').click();
// });

//   const popupClose = document.querySelector('.popup-close');
//   popupClose?.addEventListener('click', function () {
//     document.querySelector('.subscription-popup-outer').classList.add('hidden');
//     document.getElementById("popup-overlay").classList.add("hidden");

//     bypassPopup = true;
//     clickATC();
//   });

// });

// function clickATC() {
//   const mainBtn = document.querySelector('.bundle-product-atc');
//   const stickyBtn = document.querySelector('.bundle-sticky-atc');

//   if (mainBtn) {
//     mainBtn.click();
//   } else if (stickyBtn) {
//     stickyBtn.click();
//   } else {
//     console.warn("No ATC buttons found.");
//   }
// }


let isAddingToCart = false;

document.addEventListener("DOMContentLoaded", function () {
  const atcBtns = document.querySelectorAll('.bundle-product-atc, .bundle-sticky-atc');
  if (!atcBtns.length) return;

  atcBtns.forEach(btn => {
    btn.addEventListener("click", () => runAddToCart(btn));
  });
});

/* -----------------------------
   MAIN ATC FUNCTION
-------------------------------- */
async function runAddToCart(atcBtn) {
  if (!atcBtn || isAddingToCart) return;
  isAddingToCart = true;

  atcBtn.classList.add("disable", "loading");
  atcBtn.disabled = true;

  const blocks = Array.from(document.querySelectorAll('.Bundle-right-content'));

  const hasItems = blocks.some(b => parseInt(b.dataset.quantity, 10) > 0);
  if (!hasItems) {
    alert("Please select at least one scent or bundle.");
    resetATC(atcBtn);
    return;
  }

  const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;

  const hasSubscriptionEligibleItem = blocks.some(block => {
    const qty = parseInt(block.dataset.quantity, 10) || 0;
    const hasSub = block.dataset.hasSubscription;
    return qty > 0 && hasSub && hasSub !== "false" && hasSub !== "0";
  });

  if (purchaseOption === "onetime" && hasSubscriptionEligibleItem) {
    if (window.ctrSubscriptionPopup && window.ctrSubscriptionPopup.intercept()) {
      resetATC(atcBtn);
      return;
    }
  }

  const items = [];
  const processedBundles = new Set();
  let hasValidProduct = false;

  blocks.forEach((block, i) => {
    const fullBundleTitle = block.dataset.bundleTitle?.trim();
    const bundleTitle = fullBundleTitle?.split('_')[0];
    const quantity = parseInt(block.dataset.quantity, 10) || 0;
    const hasSubscription = block.dataset.hasSubscription;
    const variantIds = (block.dataset.variantIds || '')
      .split(',')
      .map(id => id.trim())
      .filter(Boolean);

    if (!variantIds.length || quantity <= 0) return;
    hasValidProduct = true;

    /* -------- BUNDLE -------- */
    if (fullBundleTitle) {
      if (processedBundles.has(fullBundleTitle)) return;
      processedBundles.add(fullBundleTitle);

      const titles = Array.from(
        block.querySelectorAll('.selected-bundle-products div')
      ).map(d => d.textContent.trim());

      variantIds.forEach(variantId => {
        const item = {
          id: parseInt(variantId, 10),
          quantity,
          properties: {
            "_bundle_items": true,
            "_unique_id": fullBundleTitle,
            "Bundle Name": bundleTitle,
            "Included Products": titles.join(', ')
          }
        };

        applySellingPlan(item, variantId, purchaseOption, hasSubscription);
        items.push(item);
      });
    }

    /* -------- SINGLE -------- */
    else {
      const variantId = variantIds[0];
      const item = {
        id: parseInt(variantId, 10),
        quantity,
        properties: {}
      };

      applySellingPlan(item, variantId, purchaseOption, hasSubscription);

      if (!Object.keys(item.properties).length) {
        delete item.properties;
      }

      items.push(item);
    }
  });

  if (!hasValidProduct) {
    alert("Please select at least one scent or bundle.");
    resetATC(atcBtn);
    return;
  }

  console.log("Final items:", items);

  if (window.ctrSubscriptionPopup && window.ctrSubscriptionPopup.applyToItems) {
    window.ctrSubscriptionPopup.applyToItems(items);
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || "Cart error");
    }

    const data = await res.json();

    window.openSidecart?.();
    window.fetchCart?.();
  } catch (err) {
    console.error("ATC error:", err);
    alert(err.message);
  } finally {
    resetATC(atcBtn);
  }
}

/* -----------------------------
   HELPERS
-------------------------------- */
function applySellingPlan(item, variantId, purchaseOption, hasSubscription) {
  if (purchaseOption === "subscription" && hasSubscription !== "false" && hasSubscription !== "0") {
    const planSelect = document.querySelector(
      `.subscription-dropdown[data-product-id="${variantId}"]`
    );
    const sellingPlanId = planSelect?.selectedOptions[0]?.value;
    if (sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId, 10);
      return;
    }
  }
  item.properties = item.properties || {};
  item.properties["Purchase Type"] = "One Time";
}

function resetATC(btn) {
  btn.classList.remove("disable", "loading");
  btn.disabled = false;
  isAddingToCart = false;
}

function toggleEmptyBundleMessage() {
  const allBlocks = document.querySelectorAll('.Bundle-right-content');
  const selectedBundles = document.querySelector('#selected-bundles');
  const hasFilledBlock = Array.from(allBlocks).some(block => {
    const title = block.getAttribute('data-bundle-title')?.trim();
    const variantId = block.getAttribute('data-variant-ids')?.trim();
    const quantity = parseInt(block.getAttribute('data-quantity'), 10);
    return (title || variantId) && quantity > 0;
  });
selectedBundles.style.display = hasFilledBlock ? 'block' : 'none';
  const emptyBundleEl = document.querySelector('.empty_bundle');
  if (emptyBundleEl) {
    emptyBundleEl.style.display = hasFilledBlock ? 'none' : 'block';
  }
}

/////////////////////////////////
/**
 * Accordion functionality for product rewards
 */
const accordionQuestions = document.querySelectorAll('.bundle-right-section .accordion-question');
accordionQuestions.forEach(question => {
  question.addEventListener('click', () => {
    const answer = question.nextElementSibling;
    const isActive = question.classList.contains('active');
    accordionQuestions.forEach(q => {
      if (q !== question) {
        q.classList.remove('active');
        q.nextElementSibling.classList.remove('active');
      }
    });
    question.classList.toggle('active');
    answer.classList.toggle('active');
  });
});
/**
 * Product Detail Drawer functionality
 */
document.addEventListener('DOMContentLoaded', function () {
  const accordionQuestions = document.querySelectorAll('.accordion-question');
  accordionQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const isActive = question.classList.contains('active');
      accordionQuestions.forEach(q => {
        if (q !== question) {
          q.classList.remove('active');
          q.nextElementSibling.classList.remove('active');
        }
      });
      question.classList.toggle('active');
      answer.classList.toggle('active');
    });
  });
});
/**
 * Product Your Selection Drawer functionality
 */
// document.addEventListener('DOMContentLoaded', function () {
//   const drawer = document.querySelector('.bundle-right-section');
//   const overlay = document.querySelector('.product-your-selection-drawer-overlay');
//   function toggleSelectionDrawer() {
//     drawer.classList.toggle('open');
//     overlay.classList.toggle('visible');
//     document.body.classList.toggle('body-drawer-open');
//   }
//   document.querySelector('.bundle-mobile-sticky-open').addEventListener('click', toggleSelectionDrawer);
//   document.querySelector('.bundle-mobile-sticky-close').addEventListener('click', toggleSelectionDrawer);
// });

// Onetime price update function code start here
let lastOneTimeDiscount = 0;

function updateOneTimePriceDisplay() {
    const placeholders = Array.from(document.querySelectorAll('#selected-scents .placeholder'));
    let totalQty = 0;
    let basePrice = 0;
    let hasHigherPriceItem = false;

    // NEW: Separate qty counters
    let discountEligibleQty = 0;
    let noDiscountQty = 0;

    // Count non-addon items
    placeholders.forEach(ph => {
        const isAddon = ph.dataset.isAddon === 'true';
        if (isAddon) return;

        const index = ph.dataset.index;
        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
        const price = parseFloat(ph.dataset.price || '0') / 100;

        const isHigherPriceItem = ph.dataset.higherpriceitem === 'true';
        if (isHigherPriceItem) hasHigherPriceItem = true;

        // NEW LOGIC — only change you needed
        if (ph.dataset.isnodiscountot === "true") {
            noDiscountQty += qty;      // these items do NOT get discount
        } else {
            discountEligibleQty += qty; // these items DO get discount
        }

        totalQty += qty;       
        basePrice += qty * price;
    });

    // Calculate discount ONLY for discount-eligible qty
      let totalDiscount = 0;
      let discountedPrice = basePrice;

      if (discountEligibleQty === 2) {
          totalDiscount = 8;
          discountedPrice = basePrice - totalDiscount;
      } 
      else if (discountEligibleQty === 3) {
          totalDiscount = 19.20;
          discountedPrice = basePrice - totalDiscount;
      } 
      else if (discountEligibleQty >= 4) {
          const discountedUnitPrice = 31.99;

          // Apply per-item pricing
          const eligibleTotal = discountEligibleQty * discountedUnitPrice;

          // Handle mixed carts safely
          const avgPrice = totalQty > 0 ? basePrice / totalQty : 0;
          const nonDiscountTotal = (totalQty - discountEligibleQty) * avgPrice;

          discountedPrice = eligibleTotal + nonDiscountTotal;

          totalDiscount = basePrice - discountedPrice;
      }

    // Save for external access
    lastOneTimeDiscount = totalDiscount;

    // Add-ons total
    let addonTotal = 0;
    placeholders.forEach(ph => {
        if (ph.dataset.isAddon !== 'true') return;

        const index = ph.dataset.index;
        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
        const price = parseFloat(ph.dataset.price || '0') / 100;

        addonTotal += qty * price;
    });

    const finalATCPrice = discountedPrice + addonTotal;

    // Your remaining code is unchanged...
    const atcButtons = document.querySelectorAll('.bundle-product-atc');
    atcButtons.forEach(btn => {
        const addToCartText = btn.querySelector('.addtocarttotal-text');
        const atcPriceDiv = btn.querySelector('.add-total-price');

        if (atcPriceDiv) atcPriceDiv.textContent = `$${finalATCPrice.toFixed(2)}`;
        if (addToCartText) addToCartText.style.display = finalATCPrice > 0 ? 'inline' : 'none';
    });

    const stickyBtn = document.querySelector('.bundle-sticky-atc');
    const stickytabheadermob = document.querySelector('.sub-inner-container .tab-header');
    const tabContents = document.querySelector('.subscription-container .tab-contents');
    let atcbutton = document.querySelector('.bundle-product-atc');

    if (stickyBtn) {
        if (totalQty === 0) {
            stickyBtn.textContent = 'Select Scents';
            if (window.matchMedia("(max-width: 767px)").matches) {
                stickytabheadermob.style.display = "none";
                if (tabContents) {
                   tabContents.style.display = "none";
                 }
                atcbutton.style.backgroundColor = "#084848";
                atcbutton.style.color = "#b6e5e5";
            }
        } else {
            stickyBtn.textContent = `Add to Cart - $${finalATCPrice.toFixed(2)}`;
            if (window.matchMedia("(max-width: 767px)").matches) {
                stickytabheadermob.style.display = "block";
                atcbutton.style.backgroundColor = "#262525";
                atcbutton.style.color = "#fff";
            }
        }
    }

    const oneTimeDisplay = document.querySelector('.one-time-discount-price');
    const oneTimeOriginalDisplay = document.querySelector('.one-time-original-price');

    if (oneTimeDisplay) {
        oneTimeDisplay.textContent = totalQty > 0 ? `$${discountedPrice.toFixed(2)}` : `$34.99`;
    }

    if (oneTimeOriginalDisplay) {
        if (totalQty > 1) {
            oneTimeOriginalDisplay.textContent = `$${basePrice.toFixed(2)}`;
            oneTimeOriginalDisplay.style.display = 'inline';
        } else {
            oneTimeOriginalDisplay.style.display = 'none';
        }
    }

    updateSubscriptionByQuantity(totalQty);
    updateTotalQty();
    updateBundleBorders();
    updateBundleProgressBar();
    window.toggleStickyBySelection?.(true);

}

// subscription price code start from here
// subscription price code start from here
function updateSubscriptionPriceDisplay() {
    const placeholders = Array.from(document.querySelectorAll('#selected-scents .placeholder'));

    let totalQty = 0;                // ALL quantities
    let discountEligibleQty = 0;     // qty that CAN get discount
    let basePrice = 0;
    let hasHigherPriceItem = false;

    let discountEligiblePrice = 0;   // price used for discount
    let noDiscountPrice = 0;         // price that should NOT get discount

    // ---- MAIN LOOP ----
    placeholders.forEach(ph => {
        const isAddon = ph.dataset.isAddon === 'true';
        if (isAddon) return;

        const isNoDiscountOT = ph.dataset.isnodiscountot === "true";
        const index = ph.dataset.index;

        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;

        const price = parseFloat(ph.dataset.price || '0') / 100;

        const isHigherPriceItem = ph.dataset.higherpriceitem === 'true';
        if (isHigherPriceItem) hasHigherPriceItem = true;

        // TOTAL qty always includes everything
        totalQty += qty;

        // BASE PRICE is always all products
        basePrice += qty * price;

        //  NEW LOGIC:
        // If item is flagged "no discount", DO NOT include in discount qty or discount price
        if (isNoDiscountOT) {
            noDiscountPrice += qty * price;
        } else {
            discountEligibleQty += qty;
            discountEligiblePrice += qty * price;
        }
    });

    // ---- DISCOUNT PERCENT BASED ONLY ON discountEligibleQty ----
    let discountPercent = 0;

    if (discountEligibleQty > 0) {
        if (discountEligibleQty === 1) discountPercent = 14;
        else if (discountEligibleQty === 2) discountPercent = 25;
        else if (discountEligibleQty === 3) discountPercent = 28;
        else if (discountEligibleQty >= 4) discountPercent = 30;
        // else if (discountEligibleQty === 5) discountPercent = 22.30;
        // else if (discountEligibleQty >= 6) discountPercent = 23.34;
    }

    // Apply discount ONLY to discount-eligible items
    const discountAmount = discountEligiblePrice * (discountPercent / 100);

    // Combined discounted part + non-discounted part
    const discountedPrice = (discountEligiblePrice - discountAmount) + noDiscountPrice;

    // ---- ADDONS ----
    let addonTotal = 0;
    placeholders.forEach(ph => {
        if (ph.dataset.isAddon !== 'true') return;

        const index = ph.dataset.index;
        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
        const price = parseFloat(ph.dataset.price || '0') / 100;

        addonTotal += qty * price;
    });

    const finalATCPrice = discountedPrice + addonTotal;

    // ---- UPDATE UI ----
    const atcButtons = document.querySelectorAll('.bundle-product-atc');
    atcButtons.forEach(btn => {
        const addToCartText = btn.querySelector('.addtocarttotal-text');
        const atcPriceDiv = btn.querySelector('.add-total-price');

        if (atcPriceDiv) atcPriceDiv.textContent = `$${finalATCPrice.toFixed(2)}`;
        if (addToCartText) addToCartText.style.display = finalATCPrice > 0 ? 'inline' : 'none';
    });

    // Sticky button
    const stickyBtn = document.querySelector('.bundle-sticky-atc');
    const stickytabheadermob = document.querySelector('.sub-inner-container .tab-header');

    if (stickyBtn) {
        if (totalQty === 0) {
            stickyBtn.textContent = 'Select Scents';
            if (window.matchMedia("(max-width: 767px)").matches) {
                stickytabheadermob.style.display = "none";
            }
        } else {
            stickyBtn.textContent = `Add to Cart - $${finalATCPrice.toFixed(2)}`;
            if (window.matchMedia("(max-width: 767px)").matches) {
                stickytabheadermob.style.display = "block";
            }
        }
    }

    const subDisplay = document.querySelector('.subscription-discount-price');
    const subOriginalDisplay = document.querySelector('.subscription-original-price');
    const subpopupdiscount = document.querySelector('.sub-discount');

    if (subDisplay) {
        subDisplay.textContent = totalQty > 0 ? `$${discountedPrice.toFixed(2)}` : `$29.99`;
    }

    if (subOriginalDisplay) {
        subOriginalDisplay.textContent = `$${basePrice.toFixed(2)}`;
        subOriginalDisplay.style.display = totalQty > 0 ? 'inline' : 'none';
    }

    // difference between subscription discount and one-time discount
    const extraSavings = lastOneTimeDiscount - discountAmount;
    subpopupdiscount.textContent = `$${Math.abs(extraSavings).toFixed(2)}`;

    const addontotal = document.querySelector('.addon-total-price');
    if (addontotal) addontotal.textContent = addonTotal === 0 ? '' : `$${addonTotal.toFixed(2)}`;

    updateSubscriptionByQuantity(totalQty);
    updateTotalQty();
    updateBundleBorders();
    updateBundleProgressBar();
    updateStickyProductList();
    window.toggleStickyBySelection?.(true);

    

}

  function updateTotalQty() { 
      let totalQty = 0;

      //  Single source of truth: sticky placeholders
      const placeholderBlocks = document.querySelectorAll(
          '#sticky-selected-scents .swiper-slide.placeholder'
      );

      placeholderBlocks.forEach(block => {
          const qty = parseInt(block.getAttribute('data-quantity')) || 0;
          totalQty += qty;
      });

      // ✅ Update ALL bundle-total-count elements
      document.querySelectorAll('.bundle-total-count').forEach(el => {
          el.textContent = `(${totalQty})`;
      });

  }

// Auto subscription select box function code start from here
//  Reusable function you can call on qty change
function updateSubscriptionByQuantity(totalQty) {
 const globalSelect = document.getElementById('global-subscription-plan');
  if (globalSelect) {
    let targetInterval = null;
    if (totalQty === 1) targetInterval = '6 week';
    else if (totalQty === 2) targetInterval = '2 month';
    else if (totalQty === 3) targetInterval = '2 month';
    else if (totalQty === 4) targetInterval = '3 month';
    else if (totalQty === 0) targetInterval = '6 week';

    if (targetInterval) {
      const matchOption = Array.from(globalSelect.options).find(opt => {
        const optInterval = opt.textContent.toLowerCase();
        return optInterval.includes(targetInterval);
      });

      if (matchOption && globalSelect.value !== matchOption.value) {
        globalSelect.value = matchOption.value;
        globalSelect.dispatchEvent(new Event('change')); // Trigger syncing logic
      }
    }
  }
}

// code end here auto subscription selsction
//  Subscription selectbox code is starting from here

document.addEventListener("DOMContentLoaded", function () {
  const globalSelect = document.getElementById('global-subscription-plan');
  if (!globalSelect) return;

  let isAutoChanging = false;
  let userManuallySelected = false;

  function extractBaseInterval(text) {
    const match = text?.toLowerCase().match(/(\d+)\s*(week|weeks|month|months)/);
    return match ? `${match[1]} ${match[2].replace(/s$/, '')}` : null;
  }

  function updateHiddenSelects(baseInterval) {
    const hiddenSelects = document.querySelectorAll('.subscription-dropdown');
    hiddenSelects.forEach(select => {
      const matchOption = Array.from(select.options).find(opt => {
        const optInterval = extractBaseInterval(opt.getAttribute('data-interval') || opt.textContent);
        return optInterval === baseInterval;
      });

      if (matchOption) {
        select.value = matchOption.value;
        select.dispatchEvent(new Event('change'));
      } else {
        console.warn(`No match for "${baseInterval}" in hidden select for product ${select.dataset.productId}`);
      }
    });
  }

  // 🔍 Detect actual user interaction
  globalSelect.addEventListener('pointerdown', function () {
    userManuallySelected = true;
  });

  // Handle dropdown change
globalSelect.addEventListener('change', function (event) {
  event.stopPropagation();
  event.stopImmediatePropagation();
  const selectedOption = globalSelect.selectedOptions[0];
  const selectedText = selectedOption?.textContent || '';
  const baseInterval = extractBaseInterval(selectedText);

    if (!baseInterval) {
      console.error("Unable to extract base interval from:", selectedText);
      return;
    }

    // ✅ Skip only true programmatic changes
    // if (isAutoChanging && !userManuallySelected) {
    //   isAutoChanging = false;
    //   return;
    // }

    // ✅ Manual or user-initiated
    updateHiddenSelects(baseInterval);

    // 🔄 Reset flags
    isAutoChanging = false;
    userManuallySelected = false;
  });

  // ✅ Optional: trigger once on load
  globalSelect.dispatchEvent(new Event('change'));

  // ✅ Expose for auto-triggering
  window.setGlobalSubscriptionAuto = function (targetInterval) {
    const matchOption = Array.from(globalSelect.options).find(opt =>
      opt.textContent.toLowerCase().includes(targetInterval)
    );

    if (matchOption && globalSelect.value !== matchOption.value) {
      isAutoChanging = true;
      globalSelect.value = matchOption.value;
      globalSelect.dispatchEvent(new Event('change'));
    }
  };
});

// subscription select box code end from here

// Remove Bundle code start from here
document.addEventListener('click', function (e) {
  const removeBtn = e.target.closest('.bundle-remove');
  if (!removeBtn) return;

  const bundleBlock = removeBtn.closest('.Bundle-right-content');
  if (!bundleBlock) return;

  // Variant IDs to remove from placeholders and match to left-side bundle
  const variantIdsRaw = bundleBlock.getAttribute('data-variant-ids') || '';
  const variantIdArray = variantIdsRaw.split(',').map(id => id.trim()).filter(Boolean);
  const variantCountMap = {};

  // Count variant ID occurrences for accurate decrement
  const bundleQty = parseInt(bundleBlock.getAttribute('data-quantity'), 10) || 1;

  // Count total units of each variant to remove
  variantIdArray.forEach(variantId => {
    variantCountMap[variantId] = (variantCountMap[variantId] || 0) + bundleQty;
  });

  // --- 1. Update RIGHT PLACEHOLDERS ---
  Object.entries(variantCountMap).forEach(([variantId, countToRemove]) => {
    const placeholder = document.querySelector(`.placeholder[data-variant-id="${variantId}"]`);
    if (!placeholder) return;

    const currentQty = parseInt(placeholder.getAttribute('data-quantity'), 10) || 0;
    const newQty = Math.max(0, currentQty - countToRemove);
    placeholder.setAttribute('data-quantity', newQty);

    const qtyEl = placeholder.querySelector('.product-qty');
    if (qtyEl) qtyEl.textContent = newQty;

    if (newQty === 0) {
      // Reset image
      const imgEl = placeholder.querySelector('.pro-right-image img');
      if (imgEl) {
        imgEl.src = 'https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538230652.png?v=1769540059';
      }

      // Remove placeholder-related attributes
      placeholder.removeAttribute('data-image');
      placeholder.removeAttribute('data-product-id');
      placeholder.removeAttribute('data-variant-id');
      placeholder.removeAttribute('data-has-subscription');
      placeholder.removeAttribute('data-quantity');
      updatePlaceholderActiveState();
    }
  });

  // --- 2. Update LEFT SIDE BUNDLE BLOCK ---
  document.querySelectorAll('.product-blockss').forEach(leftBundleBlock => {
    const blockVariantIds = [];

    // Collect all variant IDs from visible product-imageX blocks
    leftBundleBlock.querySelectorAll('[class^="product-image"]').forEach(el => {
      const variantId = el.getAttribute('data-variant-id');
      if (variantId) blockVariantIds.push(String(variantId).trim());
    });

    // Match only if all bundleBlock variant IDs are present (order doesn't matter)
    const isMatch =
      variantIdArray.length === blockVariantIds.length &&
      variantIdArray.every(id => blockVariantIds.includes(id));

    if (isMatch) {
      const qtyInput = leftBundleBlock.querySelector('.quantity__input');
      if (qtyInput) qtyInput.value = '0';

      const bundleQtty = leftBundleBlock.querySelector('.bundle-qtty');
      if (bundleQtty) bundleQtty.style.display = 'none';

      const bundleAtc = leftBundleBlock.querySelector('.bundle-atc');
      if (bundleAtc) bundleAtc.style.display = '';

      leftBundleBlock.classList.remove('active');
    }
  });

  // --- 3. Final Cleanup ---
  bundleBlock.setAttribute('data-quantity', '0');
  bundleBlock.remove();

  // --- 4. Hide bundle-selection-slots if no Bundle-right-content has data-variant-ids ---
  const hasValidBundle = Array.from(document.querySelectorAll('.Bundle-right-content'))
    .some(el => el.getAttribute('data-variant-ids'));

  if (!hasValidBundle) {
    document.querySelectorAll('.bundle-selection-slots').forEach(el => {
      el.style.display = 'none';
    });
  }

  // updateOneTimePriceDisplay();
  // updateSubscriptionPriceDisplay();
  updateAtcPriceBySelection();
  updateTabDots();
}); 

////////addons selection code add here/////

document.addEventListener("DOMContentLoaded", function () {
  const placeholders = Array.from(document.querySelectorAll('#selected-addons .placeholder'));

  // Utility: Get current selected price mode
  function getSelectedPurchaseType() {
    return document.querySelector('input[name="purchase-option"]:checked')?.value;
  }

  // Utility: Run correct price display function
  function updateCorrectPriceDisplay() {
    const selectedType = getSelectedPurchaseType();
    if (selectedType === 'subscription') {
      updateSubscriptionPriceDisplay();
    } else {
      updateOneTimePriceDisplay();
    }
  }

  // Bind addon buttons
  document.querySelectorAll('.addon-atc').forEach(button => {
    button.addEventListener('click', () => {
       
//  Activate the addon accordion section
    const accordionItem = document.querySelector('.accordion-item-addons');
    if (accordionItem) {
    const question = accordionItem.querySelector('.accordion-question');
    const answer = accordionItem.querySelector('.accordion-answer');

    if (question && answer) {
      question.classList.add('active');
      answer.classList.add('active');
    }
    }
     ///////////////////////////////
      const container = button.closest('.product-blockss');
      if (!container) return;

      const variantId = button.getAttribute('data-variant-id');
      const dataPrice = button.getAttribute('data-price');
      const images = [];
      const imgEl = container.querySelector(`.product-image1 img`);
      if (imgEl?.src && !imgEl.src.includes('no-image')) {
        images.push(imgEl.src);
      }

      images.forEach(src => {
        let slot = placeholders.find(ph => ph.dataset.image === src);
        if (!slot) slot = placeholders.find(ph => !ph.dataset.image);
        if (!slot) return;

        const idx = slot.dataset.index;
        slot.dataset.image = src;
        slot.dataset.variantId = variantId;
        slot.dataset.price = dataPrice;

        let variantInput = slot.querySelector(`input[name="variant-id-${idx}"]`);
        if (!variantInput) {
          variantInput = document.createElement('input');
          variantInput.type = 'hidden';
          variantInput.name = `variant-id-${idx}`;
          slot.appendChild(variantInput);
        }
        variantInput.value = variantId;

        let subInput = slot.querySelector(`input[name="subscription-${idx}"]`);
        if (!subInput) {
          subInput = document.createElement('input');
          subInput.type = 'hidden';
          subInput.name = `subscription-${idx}`;
          slot.appendChild(subInput);
        }

        slot.querySelector(`.product-image${idx}`).innerHTML =
          `<img src="${src}" alt="Selected">`;

        const qtyEl = slot.querySelector(`.product-qty${idx}`);
        const existingVal = parseInt(qtyEl.textContent, 10) || 0;
        qtyEl.textContent = existingVal + 1;

        const rm = slot.querySelector('.remove-btn');
        if (rm) rm.classList.remove('hidden');
      });

      const qtyInput = container.querySelector('.quantity__input');
      const minusBtn = container.querySelector('.qty-btn.minus');
      const plusBtn = container.querySelector('.qty-btn.plus');

      qtyInput.value = 1;
      updateAtcPriceBySelection();
      updateTabDots();
      button.classList.add('hidden');
      container.querySelector('.bundle-qtty').style.display = 'flex';
      container.classList.add('active');

      plusBtn.onclick = () => {
        let newVal = parseInt(qtyInput.value, 10) + 1;
        qtyInput.value = newVal;

        images.forEach(src => { 
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const existingVal = parseInt(qtyEl.textContent, 10) || 0;
            qtyEl.textContent = existingVal + 1;

            // --- ALWAYS SHOW CROSS WHEN QTY INCREASES ---
          const crossBtn = slot.querySelector('.remove-btn');
          if (crossBtn) crossBtn.classList.remove('hidden');
          }
        });
         updatePlaceholderActiveState();
        updateAtcPriceBySelection();
          updateTabDots();
      };

      minusBtn.onclick = () => {
        let newVal = parseInt(qtyInput.value, 10) - 1;
        if (newVal < 0) newVal = 0;
        qtyInput.value = newVal;

        images.forEach(src => {
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const existingVal = parseInt(qtyEl.textContent, 10) || 0;
            qtyEl.textContent = Math.max(0, existingVal - 1);

              const crossBtn = slot.querySelector('.remove-btn'); 

            if (parseInt(qtyEl.textContent, 10) === 0) {
              delete slot.dataset.image;
              delete slot.dataset.variantId;
              delete slot.dataset.subscription;

              slot.querySelector(`.product-image${idx}`).innerHTML =
                `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538228666.png?v=1753181342" alt="placeholder">`;
              qtyEl.textContent = '0';

              const variantInput = slot.querySelector(`input[name="variant-id-${idx}"]`);
              if (variantInput) variantInput.remove();

              const subInput = slot.querySelector(`input[name="subscription-${idx}"]`);
              if (subInput) subInput.remove();

        
            // --- HIDE CROSS WHEN QTY = 0 ---
            if (crossBtn) crossBtn.classList.add('hidden');
            }
            else {
            // --- SHOW CROSS IF QTY > 0 ---
            if (crossBtn) crossBtn.classList.remove('hidden');
          }
          }
        });

        if (newVal === 0) {
          button.classList.remove('hidden');
          container.querySelector('.bundle-qtty').style.display = 'none';
          container.classList.remove('active');

           // Also hide cross button explicitly when qty = 0
        images.forEach(src => {
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const crossBtn = slot.querySelector('.remove-btn');
            if (crossBtn) crossBtn.classList.add('hidden');
          }
        });

                  //  If no more selected add-ons, remove active classes from accordion
       updateAddonAccordionState();
        }

        updateAtcPriceBySelection();
         updateTabDots();
      };

      // addons
      

      //////////////////
    });
  });
// addons remove code start from here
// document.getElementById('selected-addons').addEventListener('click', function (e) {
//   const btn = e.target.closest('.remove-btn');
//   if (!btn) return;

//   const slot = btn.closest('.placeholder');
//   const idx = slot.dataset.index;
//   const imageSrc = slot.dataset.image;

//   // Reset the placeholder slot
//   slot.querySelector(`.product-image${idx}`).innerHTML =
//     `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538228666.png?v=1753181342" alt="placeholder">`;
//   slot.querySelector(`.product-qty${idx}`).textContent = '0';

//   delete slot.dataset.image;
//   delete slot.dataset.variantId;
//   delete slot.dataset.subscription;

//   // Remove hidden inputs
//   const variantInput = slot.querySelector(`input[name="variant-id-${idx}"]`);
//   if (variantInput) variantInput.remove();

//   const subInput = slot.querySelector(`input[name="subscription-${idx}"]`);
//   if (subInput) subInput.remove();

//   btn.classList.add('hidden');

//   //  Now reset the corresponding left-side block (match by imageSrc)
//   const blocks = document.querySelectorAll('.product-blockss');
//   blocks.forEach(block => {
//     const imgEl = block.querySelector('.product-image1 img');
//     if (imgEl && imgEl.src === imageSrc) {
//       const qtyInput = block.querySelector('.quantity__input');
//       const qtyBox = block.querySelector('.bundle-qtty');
//       const addBtn = block.querySelector('.addon-atc');

//       if (qtyInput) qtyInput.value = 0;
//       if (qtyBox) qtyBox.style.display = 'none';
//       if (addBtn) addBtn.classList.remove('hidden');
//        block.classList.remove('active');
//     }
//   });

//   updateAtcPriceBySelection();
//  updateAddonAccordionState();
// });

// addons remive code end from here

            function updateAddonAccordionState() {
            //  If no more selected add-ons, remove active classes from accordion
                  const accordionItem = document.querySelector('.accordion-item-addons');
                  const hasAnySelected = [...document.querySelectorAll('#selected-addons .placeholder')]
                  .some(ph => ph.dataset.image); // checks if any placeholder has an image

                  if (!hasAnySelected && accordionItem) {
                  accordionItem.querySelector('.accordion-question')?.classList.remove('active');
                  accordionItem.querySelector('.accordion-answer')?.classList.remove('active');
                  }

            }
            
  // === Handle radio clicks ===
  function bindPurchaseOptionClick() {
    document.querySelectorAll('.purchase-options').forEach(label => {
      label.addEventListener('click', () => {
        const radio = label.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          updateCorrectPriceDisplay();
          
        }
      });
    });
  }

  // === Init ===
  const selected = getSelectedPurchaseType();
  updateCorrectPriceDisplay();
  bindPurchaseOptionClick();
});

/////////////////////////////

function updateOptionPriceOnClick(type) {
  if (type === 'subscription') {
    updateSubscriptionPriceDisplay();
  } else {
    updateOneTimePriceDisplay();
  }
}

document.addEventListener("DOMContentLoaded", function () {
const mainselector = document.querySelector('#global-subscription-plan')
if(mainselector){
mainselector.addEventListener('click', function(e){
e.stopPropagation();
})
}
});

    function updateAtcPriceBySelection() {
      const selected = document.querySelector('input[name="purchase-option"]:checked')?.value;
      const atcPriceDiv = document.querySelector('.add-total-price');

      if (!atcPriceDiv) return;

      if (selected === 'subscription') {
        const subPrice = document.querySelector('.subscription-discount-price')?.textContent?.trim();
        if (subPrice) atcPriceDiv.textContent = subPrice;
          updateSubscriptionPriceDisplay();
      } else {
        const oneTimePrice = document.querySelector('.one-time-discount-price')?.textContent?.trim();
        if (oneTimePrice) atcPriceDiv.textContent = oneTimePrice;
        updateOneTimePriceDisplay();

      }
    }

//  On initial load

window.addEventListener('DOMContentLoaded', () => {
  const selected = document.querySelector('input[name="purchase-option"]:checked')?.value;
const atcTotalText = document.querySelector('.addtocarttotal-text');
  if (atcTotalText) {
    atcTotalText.style.display = 'none';
  }
  // Set static initial price
  const atcPriceDiv = document.querySelector('.add-total-price');
  if (atcPriceDiv) {
    if (selected === 'subscription') {
      const subPrice = document.querySelector('.subscription-discount-price')?.textContent?.trim();
      if (subPrice) {
        atcPriceDiv.textContent = subPrice;
      }
    } else {
      const oneTimePrice = document.querySelector('.one-time-discount-price')?.textContent?.trim();
      if (oneTimePrice) {
        atcPriceDiv.textContent = oneTimePrice;
      }
    }
  }

  bindPurchaseOptionClick();
  updateAtcPriceBySelection();
});

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('.product-detail-drawer');
  const overlay = document.querySelector('.product-detail-drawer-overlay');
  const imagesSwiper = document.querySelector(
    '.product-detail-drawer-images-swiper .swiper-wrapper'
  );
  const drawerTitle = drawer.querySelector('.drawer-title');
  const reviews = drawer.querySelector('.reviews');
  const okendoContainer = drawer.querySelector('.oke-star-rating');
  const price = drawer.querySelector('.price');
  const drawerDes = drawer.querySelector('.drawer-description');
  const inspired = drawer.querySelector('.product-detail-drawer-content .inspired');
  const flavorsList = drawer.querySelector('.flavors-list');
  const scentsdesc = drawer.querySelector('.scents-description');
  const ingredienttitle = drawer.querySelector('.ingredient-title');
  const ingredientdesc = drawer.querySelector('.ingredient-description');
  const directiontitle = drawer.querySelector('.direction-title');
  const directiondesc = drawer.querySelector('.direction-description');
  const draweraddBtn = drawer.querySelector('.drawer-add-btn');
  const scentScaleWrapper = drawer.querySelector('.scent-scale-wrapper');
  const drawerReviewsWrapper = drawer.querySelector('.drawer-reviews-wrapper');
  const reviewsSwiperWrapper = drawer.querySelector('.drawer-reviews-wrapper .swiper-wrapper');
     function renderDrawerFeatureIcons(triggerEl) {
                const wrapper = document.querySelector('.drawer-feature-icons');
                const container = wrapper.querySelector('.feature-icons-outer');

                container.innerHTML = '';
                wrapper.classList.add('hidden');

                const rawData = triggerEl.dataset.featureIcons;
                if (!rawData) return;

                let icons;
                try {
                  icons = JSON.parse(rawData.replace(/&quot;/g, '"'));
                } catch (e) {
                  console.error('[Drawer Feature Icons] JSON parse failed', e);
                  return;
                }

                if (!icons.length) return;

                icons.forEach(icon => {
                  const iconHTML = `
                    <div class="feature-icons-with-title font-degular">
                      <div class="featured-icon">
                        <img src="${icon.image}" alt="${icon.title}">
                      </div>
                      <h3 class="font-degular">${icon.title}</h3>
                    </div>
                  `;
                  container.insertAdjacentHTML('beforeend', iconHTML);
                });

                wrapper.classList.remove('hidden');

             }
function renderScentScale(scale, handle) {
  if (!scale || !handle) return '';

  const baseHandle = handle
    .toLowerCase()
    .split('-')[0]
    .trim();

  return `
    <div class="scent-scale-wrapper scale-${baseHandle} scale-${scale}">
      <div class="scent-scale-title font-degular">Scent Scale</div>

      <div class="scent-scale-bar">
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
      </div>

      <div class="scent-scale-labels">
        <span class="font-degular">LIGHT</span>
        <span class="font-degular">MEDIUM</span>
        <span class="font-degular">STRONG</span>
      </div>
    </div>
  `;
}

        

    function detailsToggleDrawer(open = true) {
    drawer.classList.toggle('open', open);
    overlay.classList.toggle('visible', open);
    document.body.classList.toggle('body-drawer-open', open);
  }
  const drawerBtns = document.querySelectorAll('.open-drawer-btn');
  const productDetailDrawerSwiper = new Swiper('.product-detail-drawer-images-swiper', {
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: true,
    pagination: {
      el: '.product-detail-drawer-images-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  drawerBtns.forEach((drawerBtn) => {
    drawerBtn.addEventListener('click', function () {
      // Open drawer
      detailsToggleDrawer(true);
      const accordionItemScents = document.querySelector('.accordion-item-scents');
      const accordionItemIngredient = document.querySelector('.accordion-item-ingredient');
      const accordionItemDirection = document.querySelector('.accordion-item-direction');
      const productType = this.dataset.productType;
      const productId = this.dataset.productId;
      const productImages = this.dataset.images;
      const productTitle = this.dataset.productTitle;
      const productPrice = this.dataset.productPrice;
      const productDescription = this.dataset.description;
      const productScentsIncludedTitle = this.dataset.scentsincludedtitle;
      const productInspired = this.dataset.inspired;
      const productFlavors = this.dataset.flavors;
      const bundleScentsIncludedDesc = this.dataset.scentsincluded;
      const productIngredientTitle = this.dataset.ingredienttitle;
      const productIngredientDesc = this.dataset.ingrediendescription;
      const productDirectionTitle = this.dataset.directiontitle;
      const productDirectionDesc = this.dataset.descriptiondesc;
      const productReviewsRaw = this.dataset.productReviews;

      flavorsList.innerHTML = '';
      scentsdesc.innerHTML = '';
      flavorsList.classList.remove('hidden');
      accordionItemScents.classList.remove('hidden');
      accordionItemIngredient.classList.remove('hidden');
      accordionItemDirection.classList.remove('hidden');
      inspired.classList.remove('hidden');
      reviews.classList.remove('hidden');
      // Images
      if (imagesSwiper) {
        if (productImages != '') {
          const productImagesData = JSON.parse(productImages);
          productImagesData.forEach((image) => {
            if (!image) return;
            productDetailDrawerSwiper.appendSlide(`
              <div class="swiper-slide">
                <div class="product-detail-drawer-image">
                  <img src="${image}" alt="Product image" />
                </div>
              </div>
            `);
            //productDetailDrawerSwiper.update();
          });
        }
      }
      // title
      if (drawerTitle && productTitle) {
        drawerTitle.textContent = productTitle;
       }

            
        // Update the drawer button's data-title attribute
        if (draweraddBtn && productTitle) {
          // alert(draweraddBtn);
          draweraddBtn.setAttribute('data-title', productTitle);
        }

         if (draweraddBtn && productType) {
          // alert(draweraddBtn);
          draweraddBtn.setAttribute('data-product-type', productType);
        }
      // Price
      // if (price) {
      //   price.textContent = productPrice ? `$${parseFloat(productPrice).toFixed(2)}` : '';
      // }
      // flavor list - scents single sku
      if (flavorsList) {
        if (productFlavors.trim() != '') {
          const flavoursData = JSON.parse(productFlavors);
          flavoursData.forEach((f) => {
            const li = document.createElement('li');
            li.innerHTML = `
              <span class="tag-icon"><img src="${f.flavour_icon}" alt="${f.flavour_title}"></span>
              ${f.flavour_title}
            `;
            flavorsList.appendChild(li);
          });
        } else {
          flavorsList.classList.add('hidden');
        }
      }
      // reviews
      // reviews
      if (okendoContainer) {
      // const okendoSnippet = this.dataset.okendoSnippet;
      const productId = this.dataset.productId;
      const okendoEl = drawer.querySelector('.okendo-reviews');

      // set Product
      window.okeWidgetApi.setProduct(okendoContainer, productId);
      
      // Inject RAW snippet HTML
      // if (okendoSnippet) {
      //   okendoContainer.innerHTML = okendoSnippet;
      // } else {
      //   console.warn('[Okendo] Missing snippet');
      //   return;
      // }

  }

      

      // inspired
      if (inspired) {
        if (productInspired) {
          inspired.innerHTML = 'Inspired by: ' + productInspired;
        } else {
          inspired.classList.add('hidden');
        }
      }
                const scentHandle = this.dataset.scentHandle;
            const scentScale  = this.dataset.scentScale;

    //  FIXED RESET (nothing else touched)
      scentScaleWrapper.classList.remove(
        'hidden',
        ...Array.from(scentScaleWrapper.classList).filter(c => c.startsWith('scale-'))
      );

      if (scentHandle && scentScale) {
        scentScaleWrapper.classList.add(`scale-${scentHandle}`, `scale-${scentScale}`);
      } else {
        scentScaleWrapper.classList.add('hidden');
      }

      if (drawerReviewsWrapper && reviewsSwiperWrapper) {
        reviewsSwiperWrapper.innerHTML = '';
        drawerReviewsWrapper.classList.add('hidden');

        if (productReviewsRaw && productReviewsRaw !== 'null') {
          try {
            const reviewsData = JSON.parse(productReviewsRaw);

            if (Array.isArray(reviewsData) && reviewsData.length) {
              reviewsData.forEach((review) => {
                const slide = document.createElement('div');
                slide.className = 'product-single-review swiper-slide';
                slide.innerHTML = `
                  <div class="product-single-review-content">
                    ${review.review_description || ''}
                  </div>
                  ${
                    review.review_title
                      ? `<p class="product-single-review-author">${review.review_title}</p>`
                      : ''
                  }
                `;
                reviewsSwiperWrapper.appendChild(slide);
              });

              drawerReviewsWrapper.classList.remove('hidden');

              // Init / Re-init swiper
              if (window.drawerReviewsSwiper) {
                window.drawerReviewsSwiper.destroy(true, true);
              }

              window.drawerReviewsSwiper = new Swiper(
                '.drawer-reviews-wrapper .review-slider-wrapper',
                {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  loop: true,
                  speed: 800,
                  autoHeight: true,
                  autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                  },
                  navigation: {
                    nextEl:
                      '.drawer-reviews-wrapper .swiper-button-next',
                    prevEl:
                      '.drawer-reviews-wrapper .swiper-button-prev',
                  },
                  breakpoints: {
                    990: {
                      spaceBetween: 30,
                      autoHeight: false,
                    },
                  },
                }
              );
            }
          } catch (e) {
            console.warn('[Drawer Reviews] Invalid review data', e);
          }
        }
      }

      renderDrawerFeatureIcons(drawerBtn);
      // description
      if (drawerDes) {
        drawerDes.innerHTML = productDescription || '';
      }
      // scents accordion
// scents accordion
      if (scentsdesc) {
        if (bundleScentsIncludedDesc != '') {
          const bundleScentsData = JSON.parse(bundleScentsIncludedDesc);

          bundleScentsData.forEach((bundleProduct) => {
            if (!bundleProduct.productTitle) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'accordion-scent-include';

            wrapper.innerHTML = `
              <div class="accordion-scent-include-title font-degular">
                ${bundleProduct.productTitle}
              </div>

              <p class="accordion-scent-include-inspired font-degular">
                Inspired by ${bundleProduct.productInspired || ''}
              </p>

              <ul class="tags font-degular">
                ${bundleProduct.productFlavours
                  .map(
                    (f) => `
                      <li>
                        <img class="tag-icon" src="${f.flavour_icon}" alt="${f.flavour_title}" />
                        ${f.flavour_title}
                      </li>
                    `
                  )
                  .join('')}
              </ul>

              ${renderScentScale(
                bundleProduct.productScentScale,
                bundleProduct.productScentHandle
          )}

            `;

            scentsdesc.appendChild(wrapper);
          });
        } else {
          accordionItemScents.classList.add('hidden');
        }
      }

      // ingredients accordion
      if (ingredientdesc) {
        if (productIngredientDesc != '') {
          ingredientdesc.innerHTML = productIngredientDesc;
        } else {
          accordionItemIngredient.classList.add('hidden');
        }
      }
      // directions accordion
      // if (directiondesc) {
      //   if (productDirectionDesc != '') {
      //     directiondesc.innerHTML = productDirectionDesc || '';
      //   } else {
      //     accordionItemDirection.classList.add('hidden');
      //   }
      // }
      // directions accordion
      if (accordionItemDirection && directiontitle && directiondesc) {
        const hasTitle = productDirectionTitle && productDirectionTitle.trim() !== '';
        const hasDesc  = productDirectionDesc && productDirectionDesc.trim() !== '';

        if (hasTitle && hasDesc) {
          directiontitle.textContent = productDirectionTitle;
          directiondesc.innerHTML = productDirectionDesc;
          accordionItemDirection.classList.remove('hidden');
        } else {
          accordionItemDirection.classList.add('hidden');
        }
      }

    });
  });
  const closeBtn = drawer.querySelector('.close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      detailsToggleDrawer(false);
      productDetailDrawerSwiper.removeAllSlides();
    });
  }

  // Close when clicking outside the drawer
    document.addEventListener('click', (e) => {
      const isDrawerOpen = drawer.classList.contains('open');
      const clickedInsideDrawer = drawer.contains(e.target);
      const clickedOpenBtn = e.target.closest('.open-drawer-btn');

      // Only close if drawer is open and click is outside
      if (isDrawerOpen && !clickedInsideDrawer && !clickedOpenBtn) {
        detailsToggleDrawer(false);
        productDetailDrawerSwiper.removeAllSlides();
      }
    });

   // Drawer add Bundle builder code start from here
        document.addEventListener('click', function(e) {
            const drawerBtn = e.target.closest('.drawer-add-btn');
            if (!drawerBtn) return;

            detailsToggleDrawer(false);

            // destroy drawer swiper safely
            if (window.productDetailDrawerSwiper) {
              productDetailDrawerSwiper.destroy(true, true);
              productDetailDrawerSwiper = null;
            }

            const productTitle = (drawerBtn.getAttribute('data-title') || '').trim();
            const productType  = (drawerBtn.getAttribute('data-product-type') || '').trim();
            if (!productTitle) return;

            // --- BUNDLES & SINGLE PRODUCTS ---
            const atcBtn = Array.from(document.querySelectorAll('.bundle-atc')).find(btn => {
              const titleAttr  = (btn.getAttribute('data-title') || '').trim();
              const singleAttr = (btn.getAttribute('data-single-product') || '').trim();
              return titleAttr === productTitle || singleAttr === productTitle;
            });

            if (!atcBtn) {
              console.warn('[Drawer] No .bundle-atc button found for title:', productTitle);
              return;
            }

            const container = atcBtn.closest('.product-blockss');
            const isBundle = atcBtn.hasAttribute('data-title');
            const qtyBox = container?.querySelector('.quantity__input');

            if (qtyBox && container.querySelector('.bundle-qtty').style.display === 'flex') {
              // Already added → increment quantity
              let newQty = parseInt(qtyBox.value, 10) + 1;
              qtyBox.value = newQty;

              const mainPlaceholders = Array.from(
                document.querySelectorAll('#selected-scents .placeholder')
              );

              const stickyPlaceholders = Array.from(
                document.querySelectorAll('#sticky-selected-scents .swiper-slide')
              );

              // ---------------- BUNDLE ----------------
              if (isBundle) {
                const bundleTitle =
                  (atcBtn.getAttribute('data-title-new') ||
                  atcBtn.getAttribute('data-title') ||
                  '').trim();

                const bundleBlock = Array.from(
                  document.querySelectorAll('.Bundle-right-content')
                ).find(el => el.getAttribute('data-bundle-title') === bundleTitle);

                if (bundleBlock) {
                  bundleBlock.querySelector('.selected-bundle-qty').textContent = newQty;
                  bundleBlock.setAttribute('data-quantity', newQty);
                }

                const productEntries = [];
                for (let i = 1; i <= 4; i++) {
                  const block = container.querySelector(`.product-image${i}`);
                  const imgEl = block?.querySelector('img');
                  if (!imgEl || imgEl.src.includes('no-image')) continue;

                  productEntries.push({
                    src: imgEl.src,
                    variantId: block.getAttribute('data-variant-id') || ''
                  });
                }

                productEntries.forEach(({ src }) => {
                  // update main placeholder
                  const mainSlot = mainPlaceholders.find(ph => ph.dataset.image === src);
                  if (mainSlot) {
                    const idx = mainSlot.dataset.index;
                    mainSlot.querySelector(`.product-qty${idx}`).textContent = newQty;
                    mainSlot.setAttribute('data-quantity', newQty);
                  }

                  // update sticky placeholder
                  const stickySlot = stickyPlaceholders.find(ph => ph.dataset.image === src);
                  if (stickySlot) {
                    const qtyEl = stickySlot.querySelector('.product-qty');
                    if (qtyEl) qtyEl.textContent = newQty;
                    stickySlot.setAttribute('data-quantity', newQty);
                  }
                });

              // ---------------- SINGLE ----------------
              } else {
                const variantId =
                  container.querySelector('.product-image1')?.getAttribute('data-variant-id');

                const block = Array.from(
                  document.querySelectorAll('.Bundle-right-content')
                ).find(el => el.dataset.variantIds === variantId);

                if (block) {
                  block.querySelector('.selected-bundle-qty').textContent = newQty;
                  block.setAttribute('data-quantity', newQty);
                }

                // main placeholder
                const mainSlot = mainPlaceholders.find(ph => ph.dataset.variantId === variantId);
                if (mainSlot) {
                  const idx = mainSlot.dataset.index;
                  mainSlot.querySelector(`.product-qty${idx}`).textContent = newQty;
                  mainSlot.setAttribute('data-quantity', newQty);
                }

                // sticky placeholder
                const stickySlot = stickyPlaceholders.find(ph => ph.dataset.variantId === variantId);
                if (stickySlot) {
                  const qtyEl = stickySlot.querySelector('.product-qty');
                  if (qtyEl) qtyEl.textContent = newQty;
                  stickySlot.setAttribute('data-quantity', newQty);
                }
              }

              // refresh UI
              toggleEmptyBundleMessage();
              updateAtcPriceBySelection();
              updatePlaceholderActiveState();

              // IMPORTANT: update sticky swiper after DOM changes
              window.bundleSwiper?.update();

            } else {
              // Not added yet → trigger original logic
              atcBtn.click();
            }
      });

  // Drawer add Bundle builder code end  here

});

// Bundle subscription sorting code start from here
document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('global-subscription-plan');
  const options = Array.from(select.options);

  // Define your desired order exactly as it appears in the text
  const order = [
    "Delivered every 4 weeks",
    "Delivered every 6 weeks",
    "Delivered every 2 months",
    "Delivered every 3 months",
    "Delivered every 4 months"
  ];

  options.sort((a, b) => {
    const indexA = order.indexOf(a.textContent.trim());
    const indexB = order.indexOf(b.textContent.trim());

    // If an option is not in the order array, put it at the end
    return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  });

  // Remove existing options and append the sorted ones
  select.innerHTML = '';
  options.forEach(opt => select.appendChild(opt));
});

// Buy once button atc code start here  for new subscription version

//  Separate Buy Once Script
document.addEventListener("DOMContentLoaded", function () {
  const buyOnceBtn = document.querySelector(".btn-onetime-buy");
  if (!buyOnceBtn) return;

  buyOnceBtn.addEventListener("click", async function (e) {
    e.preventDefault();
    buyOnceBtn.classList.add("disable", "loading");

    const blocks = Array.from(document.querySelectorAll(".Bundle-right-content"));
    const items = [];
    let hasValidProduct = false;
    const processedBundles = new Set();

    blocks.forEach((block, i) => {
      const uniqueId = `m${Math.random().toString(36).substr(2, 9)}`;
      const fullBundleTitle = block.dataset.bundleTitle?.trim();
      const bundleTitle = fullBundleTitle?.split("_")[0];
      const quantity = parseInt(block.dataset.quantity, 10) || 1;
      const variantIds = (block.dataset.variantIds || "")
        .split(",")
        .map(id => id.trim())
        .filter(Boolean);

      if (variantIds.length === 0 || quantity <= 0) return;
      hasValidProduct = true;

      //  Bundle
      if (fullBundleTitle) {
        if (processedBundles.has(fullBundleTitle)) return;
        processedBundles.add(fullBundleTitle);

        const titles = Array.from(
          block.querySelectorAll(".selected-bundle-products div")
        ).map(d => d.textContent.trim());

        variantIds.forEach((variantId, index) => {
          const item = {
            id: parseInt(variantId, 10),
            quantity: quantity,
            properties: {
              "_bundle_items": true,
              "_unique_id": uniqueId,
              "Bundle Name": bundleTitle,
              "Included Products": titles.join(", "),
              "Purchase Type": "One Time" // 🔹 Force one-time
            }
          };
          items.push(item);
        });
      }
      //  Single
      else {
        const item = {
          id: parseInt(variantIds[0], 10),
          quantity: quantity,
          properties: {
            "Purchase Type": "One Time" // 🔹 Force one-time
          }
        };
        items.push(item);
      }
    });

    //  Addons
    const addonSlots = Array.from(document.querySelectorAll("#selected-addons .placeholder"));
    addonSlots.forEach((slot, i) => {
      const variantId = slot.dataset.variantId;
      const qtyEl = slot.querySelector(`.product-qty${slot.dataset.index}`);
      const quantity = parseInt(qtyEl?.textContent || "0", 10);

      if (variantId && quantity > 0) {
        hasValidProduct = true;
        items.push({
          id: parseInt(variantId, 10),
          quantity: quantity,
          properties: { "_addon_item": true, "Purchase Type": "One Time" }
        });
      }
    });

    if (!hasValidProduct) {
      alert("Please select at least one scent or bundle.");
      buyOnceBtn.classList.remove("disable", "loading");
      return;
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.description || "Unknown cart error");
      }

      const data = await response.json();

      if (window.openSidecart) {
        window.openSidecart();
        if (window.fetchCart) window.fetchCart();
      }
    } catch (err) {
      console.error(" Buy Once failed:", err);
      alert(err);
    } finally {
      buyOnceBtn.classList.remove("disable", "loading");
    }
  });
});

// mobile addtocart sticky script
 
// document.addEventListener('DOMContentLoaded', () => {
//   const atc = document.querySelector('.btn-outer-bg');
//   if (!atc) return;

//   const stickPosition = atc.offsetTop; // button position from top
//   const offset = 150; // delay sticky by 150px
//   const scrollThreshold = 200; // start sticky after 200px scroll

//   window.addEventListener('scroll', () => {
//     const scroll = window.scrollY; // current scroll from top
//     const viewportHeight = window.innerHeight;

//     // Sticky appears after threshold and removed when button enters viewport
//     if (scroll > scrollThreshold && scroll + viewportHeight < stickPosition + offset) {
//       atc.classList.add('sticky');
//     } else {
//       atc.classList.remove('sticky');
//     }
//   });
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const arrowUp = document.querySelector('.mob-arrow-icons');      // first icon
//   const arrowDown = document.querySelector('.mob-arrow-icons-down'); // second icon
//   const tabContents = document.querySelector('.subscription-container .tab-contents');

//   // Ensure initial state (optional)
//   arrowDown.style.display = 'none'; 
//   // tabContents.style.display = 'none';

//   // Click on arrow up → show content + swap icons
//   arrowUp.addEventListener('click', () => {
//     tabContents.style.display = 'block';
//     arrowDown.style.display = 'block';
//     arrowUp.style.display = 'none';
//   });

//   // Click on arrow down → hide content + swap icons
//   arrowDown.addEventListener('click', () => {
//     tabContents.style.display = 'none';
//     arrowUp.style.display = 'block';
//     arrowDown.style.display = 'none';
//   });
// });

function updateBundleBorders() {

  const blocks = document.querySelectorAll('.Bundle-right-content');
  const validBlocks = Array.from(blocks).filter(b => 
    b.dataset.bundleTitle || b.dataset.productId || b.dataset.variantId
  );

  if (validBlocks.length === 1) {
    validBlocks[0].querySelector('.bundle-title-qty-outer').style.borderBottom = 'none';
  } 
  else if (validBlocks.length > 1) {
    validBlocks.forEach(b => {
      b.querySelector('.bundle-title-qty-outer').style.borderBottom = '1px dashed #D3D5D6';
    });
  }
}

// Banner and sticky subscription toggle code start here
document.addEventListener("DOMContentLoaded", function () {
    // 1. Selectors
    const mainToggle = document.querySelector(".toggle-switch");
    const allStickyToggles = document.querySelectorAll(".sticky-toggle-btn");
    const allStickyTexts = document.querySelectorAll(".sticky-text-ref");
    const subNote = document.querySelector(".sub-note");
    const stickysubNote = document.querySelector(".sticky-bottom-bar");

    
    const oneTimeRadio = document.getElementById("radio-onetime");
    const subRadio = document.getElementById("radio-sub");
       
    // 2. The Core Sync Function
    function syncToggles(isSubscription) {
        // --- PHYSICAL RADIO CLICK ---
        // We trigger .click() because your existing logic depends on the radio click event
        if (isSubscription) {
            if (subRadio) subRadio.click(); 
            if (mainToggle) mainToggle.classList.add("active");
        } else {
            if (oneTimeRadio) oneTimeRadio.click();
            if (mainToggle) mainToggle.classList.remove("active");
        }

        // --- UI UPDATES FOR STICKY BARS ---
        allStickyToggles.forEach(toggle => {
            if (isSubscription) {
                toggle.classList.remove("is-onetime");
            } else {
                toggle.classList.add("is-onetime");
            }
        });

        allStickyTexts.forEach(text => {
            text.textContent = isSubscription ? "+20% OFF Subscribe" : "One Time Purchase";
        });

        if (subNote) {
            subNote.textContent = isSubscription
                ? "Choose your delivery frequency in cart"
                : "Pause, skip, or cancel subscriptions anytime";
        }
       if (stickysubNote) {
            stickysubNote.textContent = isSubscription
                ? "Choose your delivery frequency in cart"
                : "Pause, skip, or cancel subscriptions anytime";
        }
        
        // --- REMAINING LOGIC ---
        if (typeof updateBundleProgressBar === "function") {
            updateBundleProgressBar();
        }
    }

    // 3. Event Listeners
    const clickTargets = [];
    if (mainToggle) clickTargets.push(mainToggle);
    allStickyToggles.forEach(el => clickTargets.push(el));

    clickTargets.forEach(target => {
        target.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Look at the radio state to determine the next move
            const isCurrentlySub = subRadio ? subRadio.checked : false;
            
            // Switch to the opposite state
            syncToggles(!isCurrentlySub);
        });
    });
     
    // 4. Handle Initial Load UI
    // Don't use .click() here or it might cause an infinite loop on load, 
    // just sync the visual classes.
    if (subRadio && subRadio.checked) {
        if (mainToggle) mainToggle.classList.add("active");
       
        allStickyToggles.forEach(t => t.classList.remove("is-onetime"));
    } else {
     
        if (mainToggle) mainToggle.classList.remove("active");
        allStickyToggles.forEach(t => t.classList.add("is-onetime"));
    }
});
// banner subscription toggle code end here
//  Bundle progress bar function code start here
function updateBundleProgressBar() {
    // --- 0. Check Mode ---
    const subNote = document.querySelector('.sub-note');
    const stickysubNote = document.querySelector(".sticky-bottom-bar");

    const subRadio = document.getElementById("radio-sub");
    const isSubscriptionMode = subRadio ? subRadio.checked : false;

    // --- 1. Calculate Total Quantity ---
// --- 1. Calculate Total Quantity ---
    const placeholders = Array.from(document.querySelectorAll('#selected-scents .placeholder'));

    let normalQty = 0;     // Non-mist items (full perks)
    let mistQty = 0;       // Mist items (free shipping only)
    let subscriptionQty = 0; // Combined (for free shipping base)

    if (isSubscriptionMode) {

        placeholders.forEach(ph => {

            if (ph.dataset.isAddon === 'true') return;

            const index = ph.dataset.index;
            const qtyEl = ph.querySelector(`.product-qty${index}`);
            const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;

            if (ph.dataset.isMist === 'true') {
                mistQty += qty;
            } else {
                normalQty += qty;
            }

        });

        subscriptionQty = normalQty + mistQty;
    }

    // --- 2. Update ALL Progress Bar Wrappers ---
    const allWrappers = document.querySelectorAll('.perk-progress-wrapper');
    const selector_wrappers = document.querySelectorAll('.selection-outer-bg');
    
    allWrappers.forEach(wrapper => {
        subscriptionQty > 0 ? wrapper.classList.add('bundle-started') : wrapper.classList.remove('bundle-started');
    });

    selector_wrappers.forEach(sw => {
        subscriptionQty > 0 ? sw.classList.add('sel-bundle-started') : sw.classList.remove('sel-bundle-started');
    });

    // --- 3. Determine Progress Percentage ---
        let progressPercent = 0;
        let useMistLogic = normalQty === 0 && mistQty > 0;

        if (useMistLogic) {
            //  Mist logic (only free shipping tier)

            if (mistQty >= 1) progressPercent = 14; // Free shipping unlocked
            if (mistQty >= 2) progressPercent = 14; // Still capped
            if (mistQty >= 3) progressPercent = 14;
            if (mistQty >= 4) progressPercent = 14;

        } else {
            // Normal bundle logic (full tiers)

            if (normalQty === 1) progressPercent = 14;
            else if (normalQty === 2) progressPercent = 50;
            else if (normalQty === 3) progressPercent = 75;
            else if (normalQty >= 4) progressPercent = 100;
        }

    // --- 4. Apply Width to ALL Fills ---
    const allFills = document.querySelectorAll('.perk-progress-fill');
    allFills.forEach(fill => {
        fill.style.width = `${progressPercent}%`;
    });

  
      // --- 5. Update ALL Icons/Steps ---
      allWrappers.forEach(wrapper => {

          const steps = wrapper.querySelectorAll('.perk-step');

          steps.forEach((step, i) => {
              step.classList.remove('active');

              let isActive = false;

              if (useMistLogic) {
                  // Only activate first step (free shipping)
                  if (i === 0 && mistQty >= 1) isActive = true;

              } else {
                  // Normal tier logic
                  if (i === 0 && normalQty >= 1) isActive = true;
                  if (i === 1 && normalQty >= 2) isActive = true;
                  if (i === 2 && normalQty >= 4) isActive = true;
              }

              if (isActive) step.classList.add('active');
          });

      });

    // --- 6. Update Dynamic Progress Text ---
        const progressTexts = document.querySelectorAll('.progress-gifts');
        let message = "Add 1 item to unlock free shipping";

        if (useMistLogic) {

            if (mistQty === 0) {
                message = "Add 1 mist to unlock free shipping";
            } else {
                message = "Free shipping unlocked 🎉";
            }

        } else {

            if (normalQty === 1) {
                message = "1 ITEM AWAY FROM FREE GIFT WORTH $10!";
            } else if (normalQty === 2) {
                message = "2 ITEMS AWAY FROM FREE GIFTS WORTH $25!";
            } else if (normalQty === 3) {
                message = "1 ITEM AWAY FROM BIGGEST SAVINGS + FREEBIES";
            } else if (normalQty >= 4) {
                message = "You have unlocked max freebies & discounts 🎉";
            }

        }

        progressTexts.forEach(txt => {
            txt.innerHTML = message;
        });

    // --- 7. Update Sub Note Text ---
    if (subNote) {
        subNote.textContent = isSubscriptionMode
            ? "Choose your delivery frequency in cart"
            : "Pause, skip, or cancel subscriptions anytime";
    }
        if (stickysubNote) {
        stickysubNote.textContent = isSubscriptionMode
            ? "Choose your delivery frequency in cart"
            : "Pause, skip, or cancel subscriptions anytime";
    }
    // --- 8. Sync Sticky Toggle UI with Radio State ---
      const allStickyToggles = document.querySelectorAll(".sticky-toggle-btn");

      allStickyToggles.forEach(toggle => {
          if (isSubscriptionMode) {
              toggle.classList.remove("is-onetime");
          } else {
              toggle.classList.add("is-onetime");
          }
});

}
  // bundle progress bar function code end here

  
  // bundle placeholder slider code start here

  document.addEventListener("DOMContentLoaded", function() {
    var bundleSwiper = new Swiper(".bundle-selection-slider", {
      slidesPerView: 9,      //  Shows 9 items at once
      spaceBetween: 30,      // Space between circles (adjust as needed)
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      
      // Optional: Prevent sliding if not enough items
      
      // Responsive Breakpoints (Optional: reduces count on mobile so they aren't tiny)
      breakpoints: {
        320: {
          slidesPerView: 5,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 10
        },
        1200: {
          slidesPerView: 9,
          spaceBetween: 30
        }
      }
    });
  });

  // bundle placeholder slide code end here

    // bundle stciky placeholder slider code start here

document.addEventListener("DOMContentLoaded", function() {
  var bundleSwiper = new Swiper(".sticky-selector-slider", {
    slidesPerView: 8,
    spaceBetween: 20,
    watchOverflow: true,
    loop: true,           
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      1200: {
        slidesPerView: 8,
        spaceBetween: 20
      }
    }
  });
});

  // bundle sticky placeholder slide code end here

  function updateStickyProductList() {
      const stickyList = document.getElementById('sticky-selected-list');
      if (!stickyList) return;

      // 1. Clear current list to rebuild
      stickyList.innerHTML = '';

      // 2. Target placeholders that have an assigned product ID
      const activeProducts = document.querySelectorAll('#selected-scents .placeholder:not([data-product-id=""])');
      
      // Counter to track items that actually have quantity > 0
      let visibleItemsCount = 0;

      activeProducts.forEach(product => {
          const index = product.getAttribute('data-index');
          const qtyEl = product.querySelector(`.product-qty${index}`);
          const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;

          // SKIP if quantity is 0 or less
          if (qty <= 0) return;

          visibleItemsCount++;

          const productId = product.getAttribute('data-product-id');
          const imageUrl = product.getAttribute('data-image');
          const title = product.getAttribute('data-title') || "Scent"; 

          // 3. Create and append the row
          const itemHtml = `
              <div class="sticky-product-row" data-id="${productId}">
                  <div class="sticky-product-info">
                      <div class="sticky-img-wrap">
                          <img src="${imageUrl}" alt="${title}">
                      </div>
                      <span class="sticky-product-name font-degular">${title}</span>
                  </div>
                  <div class="sticky-product-qty font-degular">${qty}</div>
              </div>
          `;
          stickyList.insertAdjacentHTML('beforeend', itemHtml);
      });

      // 4. If no items had a quantity > 0, show the empty message
      if (visibleItemsCount === 0) {
          stickyList.innerHTML = '<p class="empty-msg" style="text-align:center; padding: 20px; color: #666;">No scents selected</p>';
      }
  }

/////// mobile sticky see deatil btn popup
document.addEventListener("click", function (event) {
  const detailBtn = event.target.closest('.see-detail-inn');
  if (!detailBtn) return;

  const stickyPopup = document.querySelector('.mobile-sticky-popup');
  const selectionSlider = document.querySelector('.sticky-bundle-selection-slider');

  if (!stickyPopup) return;

  const isHidden = stickyPopup.classList.toggle('hidden');

  if (selectionSlider) {
    selectionSlider.classList.toggle('hidden', !isHidden);
  }

  const textEl = detailBtn.querySelector('.detail-text');

  if (isHidden) {
    textEl.textContent = 'View Details';
    detailBtn.classList.remove('is-open');
  } else {
    textEl.textContent = 'Hide Details';
    detailBtn.classList.add('is-open');
  }
});

// select al best seller buttons
document.addEventListener("DOMContentLoaded", function () {
  const bestSellerTriggerBtns = document.querySelectorAll('.bundle-best-btn');
  if (!bestSellerTriggerBtns.length) return;

  bestSellerTriggerBtns.forEach(triggerBtn => {
    triggerBtn.addEventListener('click', () => {
      const bestSellerButtons = document.querySelectorAll(
        '.bundle-atc[data-bestseller="true"]'
      );

      bestSellerButtons.forEach(btn => {
        const container = btn.closest('.product-blockss');
        if (!container) return;

        const qtyBox = container.querySelector('.bundle-qtty');
        const plusBtn = container.querySelector('.qty-btn.plus');

        // If already selected → increment qty
        if (qtyBox && qtyBox.style.display === 'flex' && plusBtn) {
          plusBtn.click();
        } 
        // First-time add
        else {
          btn.click();
        }
      });
    });
  });
});

// mozi lab add to cart code start here

document.addEventListener('click', function (e) {
  const button = e.target.closest('.lab-atc');
  if (!button) return;

  e.preventDefault();

  // prevent double click
  if (button.classList.contains('loading')) return;

  button.classList.add('disable', 'loading');

  const variantId = button.dataset.variantId;
  if (!variantId) {
    console.error('No variant ID found');
    button.classList.remove('disable', 'loading');
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(data => {

    // ---- OPEN CART DRAWER ----
    if (window.openSidecart) {
      window.openSidecart();
      if (window.fetchCart) window.fetchCart();
    }
  })
  .catch(err => {
    console.error('Add to cart error:', err);
  })
  .finally(() => {
    button.classList.remove('disable', 'loading');
  });
});

/* ===============================
   RESET / CLEAR ALL SELECTIONS
================================ */

document.addEventListener('click', function (e) {
  const clearBtn = e.target.closest('.reset_btn');
  if (!clearBtn) return;

  /* 1. Clear placeholders (Main + Sticky) */
  document.querySelectorAll('.selection-slots .placeholder').forEach(slot => {
    const idx = slot.dataset.index;

    const imgBox = slot.querySelector(`.product-image${idx}`);
    const qtyBox = slot.querySelector(`.product-qty${idx}`);
    const removeBtn = slot.querySelector('.remove-btn');

    if (imgBox) {
      imgBox.innerHTML =
        `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538230652.png?v=1769540059" alt="placeholder">`;
    }

    if (qtyBox) qtyBox.textContent = '0';
    if (removeBtn) removeBtn.classList.add('hidden');

    delete slot.dataset.image;
    delete slot.dataset.productId;
    delete slot.dataset.variantId;
    // delete slot.dataset.quantity;
    slot.dataset.quantity = '0';
    delete slot.dataset.hasSubscription;
    delete slot.dataset.title;
    delete slot.dataset.price;
    delete slot.dataset.isAddon;
    delete slot.dataset.higherpriceitem;
    delete slot.dataset.isnodiscountot;

    if (typeof updateProductRightBlocksActive === 'function') {
      updateProductRightBlocksActive(slot);
    }
  });

  /* 2. Clear Bundle / Single summary blocks */
  document.querySelectorAll('.Bundle-right-content').forEach(block => {
    block.removeAttribute('data-bundle-title');
    block.removeAttribute('data-image');
    block.removeAttribute('data-product-id');
    block.removeAttribute('data-variant-ids');
    block.removeAttribute('data-has-subscription');
    block.setAttribute('data-quantity', '0');

    const titleEl = block.querySelector('.selected-bundle-title');
    const productsEl = block.querySelector('.selected-bundle-products');
    const qtyEl = block.querySelector('.selected-bundle-qty');

    if (titleEl) titleEl.textContent = '';
    if (productsEl) productsEl.innerHTML = '';
    if (qtyEl) qtyEl.textContent = '';
  });

  /* 3. Reset product cards (Singles + Bundles) */
  document.querySelectorAll('.product-blockss').forEach(container => {
    const qtyInput = container.querySelector('.quantity__input');
    const atcBtn = container.querySelector('.bundle-atc');
    const qtyWrapper = container.querySelector('.bundle-qtty');

    if (qtyInput) qtyInput.value = 0;
    if (atcBtn) atcBtn.style.display = '';
    if (qtyWrapper) qtyWrapper.style.display = 'none';

    container.classList.remove('active');
  });

  /* 4. Reset prices + UI */
  if (typeof toggleEmptyBundleMessage === 'function') {
    toggleEmptyBundleMessage();
  }

  if (typeof updateOneTimePriceDisplay === 'function') {
    updateOneTimePriceDisplay();
  }

  if (typeof updateSubscriptionPriceDisplay === 'function') {
    updateSubscriptionPriceDisplay();
  }

  if (typeof updatePlaceholderActiveState === 'function') {
    updatePlaceholderActiveState();
  }

  if (typeof updateAtcPriceBySelection === 'function') {
    updateAtcPriceBySelection();
  }

  if (typeof updateTabDots === 'function') {
    updateTabDots();
  }

});

  document.addEventListener("DOMContentLoaded", function () {
    const stickyCart = document.querySelector('.product__sticky-bar');
    const subscription = document.querySelector('.selection-outer-bg');

    function isFullyPast(el) {
      const rect = el.getBoundingClientRect();
      return rect.bottom <= 0;
    }

    function isMobile() {
      return window.innerWidth <= 768;
    }

    // DESKTOP ONLY scroll logic
    function handleDesktopScroll() {
      if (isMobile()) return;

      if (isFullyPast(subscription)) {
        stickyCart.classList.remove('hidden');
        document.body.classList.add('stickycart-bar-show');
      } else {
        stickyCart.classList.add('hidden');
        document.body.classList.remove('stickycart-bar-show');
      }
    }

    // Initial state
    stickyCart.classList.add('hidden');
    document.body.classList.remove('stickycart-bar-show');

    window.addEventListener('scroll', handleDesktopScroll);
    window.addEventListener('resize', handleDesktopScroll);

    // Expose mobile controller
    window.toggleStickyBySelection = function () {
      const stickyCart = document.querySelector('.product__sticky-bar');
      if (!stickyCart) return;

      // Desktop untouched
      if (window.innerWidth > 768) return;

      if (hasAnySelection()) {
        stickyCart.classList.remove('hidden');
        document.body.classList.add('stickycart-bar-show');
      } else {
        stickyCart.classList.add('hidden');
        document.body.classList.remove('stickycart-bar-show');
      }
    };

  });

function hasAnySelection() {
  return Array.from(
    document.querySelectorAll('.selection-slots .placeholder')
  ).some(slot => parseInt(slot.dataset.quantity || '0', 10) > 0);
}

 

 

